import { jsx as d, jsxs as M, Fragment as K } from "react/jsx-runtime";
import { Card as gt, Box as T, IconButton as N, Menu as pt, Typography as j, Paper as ft, CircularProgress as Nt, InputAdornment as Pe, Divider as Oe, Autocomplete as mt, TextField as ue, Table as Ot, TableContainer as jt, TableHead as qt, TableRow as ye, TableCell as Fe, TableSortLabel as Wt, TableBody as Ut, TableFooter as Kt, Toolbar as je, Alert as Xt, Tooltip as ie, MenuItem as U, ListItemText as ve, Checkbox as qe, CheckboxWithLabel as Jt, Button as Ct, ListItem as We, ListItemIcon as Ue, FormControlLabel as Yt, List as Ke, Drawer as ht, Link as Zt, CardActionArea as Qt, CardMedia as en, CardContent as tn, Collapse as nn } from "@global-engineering-shared/gweb-material-ui";
import { combineClasses as b } from "@global-engineering-shared/object-utils";
import { makeStyles as R, createStyles as y, Collapse as Xe, alpha as ne, darken as on, useTheme as Ie, LinearProgress as sn, Popper as ln, ClickAwayListener as rn } from "@material-ui/core";
import { ChevronRightLightIcon as St, EllipsisVerticalLightIcon as wt, CrossLightIcon as ge, SearchHeavyIcon as an, SearchLightIcon as un, ChevronDownLightIcon as Je, ChevronLeftEndLightIcon as cn, ChevronLeftLightIcon as dn, ChevronRightEndLightIcon as gn, ColumnsLightIcon as pn, FilterLightIcon as fn, ChevronUpLightIcon as Pt, EditLightIcon as mn, CheckLightIcon as vt } from "@global-engineering-shared/gweb-global-icons";
import * as Ee from "react";
import { useState as O, forwardRef as Ye, useRef as H, useEffect as ee, useMemo as xe, useCallback as se, createContext as Cn, useContext as hn, createElement as Sn, Fragment as pe, Children as wn, isValidElement as Pn, cloneElement as vn } from "react";
import { Skeleton as bn } from "@material-ui/lab";
import { once as Rn } from "lodash-es";
import { parseISO as oe, formatISO as be } from "date-fns";
import { Chip as Ze, NumberField as Ae, DatePicker as yn, DateRangePicker as Fn, DateTimePicker as In, CheckboxGroup as xn, getChipBackgroundColour as lt, getChipColour as $n, ChipIcon as _n } from "@global-engineering-shared/gweb-material-global";
import q from "classnames";
const Dl = () => /* @__PURE__ */ d("div", { children: "TestComponent" }), Gn = R(
  () => y({
    root: () => ({
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between"
    })
  }),
  { name: "gGlobalCard" }
), Ll = ({ children: e, classes: n, ...t }) => {
  const o = b(Gn(), n);
  return /* @__PURE__ */ d(gt, { classes: o, ...t, children: e });
}, Vn = R(
  (e) => y({
    root: () => ({
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      padding: e.spacing(1),
      gap: e.spacing(1)
    })
  }),
  { name: "gGlobalCardHeader" }
), El = (e) => {
  const { children: n, ref: t, classes: o, ...s } = e, l = b(Vn(), o);
  return /* @__PURE__ */ d(T, { className: l.root, ...s, children: n });
}, Tn = R(() => y({}), {
  name: "gGlobalCardHeaderAction"
}), Al = (e) => {
  const { children: n, ref: t, classes: o, ...s } = e, l = b(Tn(), o);
  return /* @__PURE__ */ d("div", { className: l.root, ...s, children: n });
}, Mn = R(
  () => y({
    root: ({ open: e }) => ({
      transform: e && "rotate(90deg)"
    })
  }),
  { name: "gGlobalCardHeaderCollapsible" }
), kl = (e) => {
  const {
    IconButtonProps: n,
    Icon: t = St,
    IconProps: o,
    onOpen: s,
    open: l,
    classes: r
  } = e, i = () => {
    s();
  }, a = b(Mn({ open: l }), r);
  return /* @__PURE__ */ d(
    N,
    {
      onClick: i,
      classes: {
        root: a.root
      },
      size: "small",
      ...n,
      children: /* @__PURE__ */ d(t, { ...o, titleAccess: "Collapse Icon" })
    }
  );
}, Dn = R(() => y({}), {
  name: "gGlobalCardHeaderContent"
}), Bl = (e) => {
  const { children: n, ref: t, classes: o, ...s } = e, l = b(Dn(), o);
  return /* @__PURE__ */ d(T, { className: l.root, ...s, children: n });
}, Ln = R(
  () => y({
    root: () => ({
      marginLeft: "auto"
    })
  }),
  { name: "gGlobalCardHeaderMenu" }
), zl = (e) => {
  const { MenuItems: n, classes: t, IconButtonProps: o, MenuProps: s, ...l } = e, r = b(Ln(), t), [i, a] = O(null), c = (g) => {
    a(g.currentTarget);
  }, p = Ye(
    (g, u) => n ? /* @__PURE__ */ d("div", { ref: u, children: /* @__PURE__ */ d(n, { ...g }) }) : null
  ), f = () => {
    a(null);
  };
  return /* @__PURE__ */ M(T, { className: r.root, ...l, children: [
    /* @__PURE__ */ d(
      N,
      {
        onClick: c,
        classes: {
          root: r.iconButton
        },
        size: "small",
        ...o,
        children: /* @__PURE__ */ d(
          wt,
          {
            titleAccess: "Menu Icon",
            classes: {
              root: r.icon
            }
          }
        )
      }
    ),
    /* @__PURE__ */ d(
      pt,
      {
        anchorEl: i,
        keepMounted: !0,
        open: !!i,
        onClose: f,
        classes: {
          paper: r.paper
        },
        ...s,
        children: /* @__PURE__ */ d(p, { handleClose: f })
      }
    )
  ] });
}, En = R(
  (e) => y({
    root: () => ({
      display: "flex",
      flexDirection: "column"
    }),
    title: () => ({
      fontWeight: 600,
      color: e.palette.text.primary
    }),
    subtitle: () => ({
      color: e.palette.text.secondary
    })
  }),
  { name: "gGlobalCardHeaderTitle" }
), An = (e) => {
  const { children: n, ...t } = e;
  return /* @__PURE__ */ d(j, { ...t, variant: "body1", children: n });
}, kn = (e) => {
  const { children: n, ...t } = e;
  return /* @__PURE__ */ d(j, { ...t, variant: "caption", children: n });
}, Hl = (e) => {
  const {
    TitleComponent: n = An,
    TitleComponentProps: t,
    SubTitleComponent: o = kn,
    SubTitleComponentProps: s,
    ref: l,
    classes: r,
    ...i
  } = e, a = b(En(), r);
  return /* @__PURE__ */ M("div", { ...i, className: a.root, children: [
    /* @__PURE__ */ d(
      n,
      {
        classes: {
          root: a.title
        },
        ...t
      }
    ),
    /* @__PURE__ */ d(
      o,
      {
        classes: {
          root: a.subtitle
        },
        ...s
      }
    )
  ] });
}, Bn = R(() => y({}), { name: "gGlobalCardBody" }), zn = (e) => {
  const { children: n, ref: t, classes: o, ...s } = e, l = b(Bn(), o);
  return /* @__PURE__ */ d(T, { className: l.root, ...s, children: n });
}, Nl = (e) => {
  const { open: n, ...t } = e;
  return /* @__PURE__ */ d(Xe, { in: n, "aria-label": "globalCardCollapse", "aria-hidden": !n, children: /* @__PURE__ */ d(zn, { ...t }) });
}, Hn = R(
  () => y({
    root: () => ({
      display: "flex",
      justifyContent: "space-between"
    })
  }),
  { name: "gGlobalCardFooter" }
), Ol = (e) => {
  const { children: n, ref: t, classes: o, ...s } = e, l = b(Hn(), o);
  return /* @__PURE__ */ d(T, { ...s, className: l.root, children: n });
}, Nn = R(() => y({}), {
  name: "gGlobalCardFooterLeftContent"
}), jl = (e) => {
  const { children: n, ref: t, classes: o, ...s } = e, l = b(Nn(), o);
  return /* @__PURE__ */ d(T, { className: l.root, ...s, children: n });
}, On = R(
  () => y({
    root: () => ({
      marginLeft: "auto"
    })
  }),
  { name: "gGlobalCardFooterRightContent" }
), ql = (e) => {
  const { children: n, ref: t, classes: o, ...s } = e, l = b(On(), o);
  return /* @__PURE__ */ d(T, { className: l.root, ...s, children: n });
}, rt = "0px 2px 4px 0px rgba(0, 0, 0, 0.10)", jn = R(
  (e) => y({
    inputRoot: ({ inputValue: n }) => ({
      "&&": {
        height: "40px",
        padding: e.spacing(0, 2),
        borderRadius: e.spacing(1),
        background: n ? e.palette.common.white : e.palette.violet[100],
        borderColor: e.palette.violet[200],
        color: e.palette.primary.dark,
        "& fieldset": n ? {
          border: "none",
          boxShadow: n ? rt : "none"
        } : {},
        "& input": {
          fontWeight: 400
        }
      }
    }),
    startAdornment: ({ inputValue: n }) => ({
      display: n ? "none" : "flex",
      color: e.palette.primary.dark,
      paddingRight: e.spacing(1)
    }),
    endAdornment: ({ inputValue: n }) => ({
      display: n ? "flex" : "none",
      color: e.palette.primary.main,
      height: "24px",
      "& svg": {
        cursor: "pointer"
      },
      "& hr": {
        margin: e.spacing(0, 2)
      }
    }),
    search: {
      height: "100%",
      display: "none"
    },
    inputFocused: {
      "&&&": {
        background: e.palette.common.white,
        "& fieldset": {
          border: "none",
          boxShadow: rt
        },
        "& $startAdornment": {
          display: "none"
        },
        "& $endAdornment": {
          display: "flex"
        },
        "& $search": {
          display: "flex",
          alignItems: "center"
        }
      }
    },
    option: {
      paddingLeft: e.spacing(1.5),
      "&:hover": {
        background: e.palette.blue[50]
      },
      "&:active": {
        background: e.palette.blue[50]
      },
      '&[data-focus="true"]': {
        background: e.palette.blue[50]
      }
    }
  }),
  { name: "gAsyncSearch" }
), qn = R(
  (e) => y({
    paper: {
      borderRadius: e.spacing(1)
    },
    showMoreWrapper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      paddingBottom: e.spacing(1),
      "& p": {
        cursor: "pointer",
        fontSize: "0.875rem",
        fontWeight: 600,
        color: e.palette.primary.main
      }
    },
    loader: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: e.spacing(1, 0)
    },
    noResults: {
      fontSize: "0.875rem",
      fontWeight: 400,
      padding: e.spacing(2)
    }
  }),
  { name: "gSearchPaper" }
), Wn = ({
  loading: e,
  inputValue: n,
  searchedData: t,
  handleShowAllSearchResults: o,
  searchResultsLimit: s = 8,
  showMore: l = !0,
  showMoreLabel: r = "Show all results",
  noResultsText: i = `No results found for “${n}”`,
  classes: a = {},
  ...c
}) => {
  const p = b(qn(), a), { children: f } = c, g = !t.length && n, u = l && t.length > s;
  return /* @__PURE__ */ d(
    ft,
    {
      ...c,
      classes: {
        root: p.paper
      },
      children: e ? /* @__PURE__ */ d(T, { className: p.loader, children: /* @__PURE__ */ d(Nt, { size: 15 }) }) : /* @__PURE__ */ M(K, { children: [
        g && /* @__PURE__ */ d(j, { className: p.noResults, children: i }),
        !g && /* @__PURE__ */ M(T, { children: [
          f,
          u && /* @__PURE__ */ d(T, { className: p.showMoreWrapper, onMouseDown: o, children: /* @__PURE__ */ d(j, { children: r }) })
        ] })
      ] })
    }
  );
};
function Un(e, n, t) {
  var o = this, s = H(null), l = H(0), r = H(null), i = H([]), a = H(), c = H(), p = H(e), f = H(!0);
  p.current = e;
  var g = typeof window < "u", u = !n && n !== 0 && g;
  if (typeof e != "function")
    throw new TypeError("Expected a function");
  n = +n || 0;
  var m = !!(t = t || {}).leading, C = !("trailing" in t) || !!t.trailing, h = "maxWait" in t, S = "debounceOnServer" in t && !!t.debounceOnServer, w = h ? Math.max(+t.maxWait || 0, n) : null;
  ee(function() {
    return f.current = !0, function() {
      f.current = !1;
    };
  }, []);
  var F = xe(function() {
    var v = function(D) {
      var E = i.current, L = a.current;
      return i.current = a.current = null, l.current = D, c.current = p.current.apply(L, E);
    }, P = function(D, E) {
      u && cancelAnimationFrame(r.current), r.current = u ? requestAnimationFrame(D) : setTimeout(D, E);
    }, x = function(D) {
      if (!f.current)
        return !1;
      var E = D - s.current;
      return !s.current || E >= n || E < 0 || h && D - l.current >= w;
    }, G = function(D) {
      return r.current = null, C && i.current ? v(D) : (i.current = a.current = null, c.current);
    }, I = function D() {
      var E = Date.now();
      if (x(E))
        return G(E);
      if (f.current) {
        var L = n - (E - s.current), B = h ? Math.min(L, w - (E - l.current)) : L;
        P(D, B);
      }
    }, A = function() {
      if (g || S) {
        var D = Date.now(), E = x(D);
        if (i.current = [].slice.call(arguments), a.current = o, s.current = D, E) {
          if (!r.current && f.current)
            return l.current = s.current, P(I, n), m ? v(s.current) : c.current;
          if (h)
            return P(I, n), v(s.current);
        }
        return r.current || P(I, n), c.current;
      }
    };
    return A.cancel = function() {
      r.current && (u ? cancelAnimationFrame(r.current) : clearTimeout(r.current)), l.current = 0, i.current = s.current = a.current = r.current = null;
    }, A.isPending = function() {
      return !!r.current;
    }, A.flush = function() {
      return r.current ? G(Date.now()) : c.current;
    }, A;
  }, [m, h, n, w, C, u, g, S]);
  return F;
}
const Kn = (e, n) => Un(e, n), Xn = ({
  loading: e,
  searchTerm: n,
  debounceTime: t,
  clearSearchResults: o,
  setSearchTerm: s,
  handleSearch: l,
  handleSelection: r,
  showAllSearchResults: i,
  ref: a,
  showMore: c = !0
}) => {
  const [p, f] = O(""), [g, u] = O(!1), [m, C] = O(!1), h = () => {
    C(!1);
  }, S = () => {
    u(!0);
  }, w = () => {
    u(!1);
  }, F = (L) => {
    o ? o(L) : s("");
  }, v = (L) => {
    c && (L.stopPropagation(), a && a.current && a.current.blur(), p ? s(p) : F(!0), C(!1), i && i());
  }, P = (L) => {
    L.key === "Enter" && (L.preventDefault(), v(L));
  }, G = Kn((L) => {
    e || (l && l(L), C(!!L));
  }, t), I = (L, B, k) => {
    k === "input" && (f(B), G(B));
  }, A = (L) => {
    const B = !g && !!n;
    L == null || L.stopPropagation(), f(""), C(!1), F(B);
  }, D = (L, B, k) => {
    k === "select-option" && r && r(B);
  }, E = () => {
    !n && !e && f("");
  };
  return ee(() => {
    p || A();
  }, [g, p]), {
    inputValue: p,
    isInputActive: g,
    open: m,
    handleClose: h,
    handleFocus: S,
    handleBlur: w,
    handleKeyDown: P,
    handleInputChange: I,
    handleClearSearch: A,
    handleOnSelection: D,
    handleShowAllSearchResults: v,
    clearInputValue: E
  };
}, Wl = ({
  searchTerm: e,
  searchedData: n,
  SearchOption: t,
  setSearchTerm: o,
  clearSearchResults: s,
  placeholder: l = "Search",
  searchResultsLimit: r = 8,
  showMoreLabel: i,
  showMore: a = !0,
  noResultsText: c,
  searching: p = !1,
  loading: f = !1,
  debounceTime: g = 350,
  ClearIcon: u = ge,
  SearchIcon: m = an,
  SearchPaperComponent: C,
  handleSearch: h,
  handleSelection: S,
  getOptionLabel: w,
  classes: F = {},
  paperClasses: v = {},
  disableCloseOnSelect: P = !1,
  autoFocus: x = !1,
  disableEndAdornment: G = !1,
  showAllSearchResults: I
}) => {
  const A = H(null), {
    inputValue: D,
    open: E,
    handleClearSearch: L,
    handleShowAllSearchResults: B,
    handleInputChange: k,
    handleOnSelection: le,
    handleClose: me,
    handleFocus: st,
    handleBlur: At,
    handleKeyDown: kt,
    clearInputValue: Bt
  } = Xn({
    loading: f,
    searchTerm: e,
    debounceTime: g,
    clearSearchResults: s,
    setSearchTerm: o,
    handleSearch: h,
    handleSelection: S,
    showAllSearchResults: I,
    ref: A,
    showMore: a
  }), te = b(jn({ inputValue: D }), F);
  ee(() => {
    E || Bt();
  }, [E]);
  const zt = G ? null : /* @__PURE__ */ M(Pe, { position: "end", className: te.endAdornment, children: [
    !!D && /* @__PURE__ */ d(u, { onClick: L, "data-testid": "clearIcon" }),
    /* @__PURE__ */ M(T, { className: te.search, children: [
      /* @__PURE__ */ d(Oe, { orientation: "vertical" }),
      /* @__PURE__ */ d(
        m,
        {
          fontSize: "small",
          titleAccess: "searchIcon-end",
          onClick: B
        }
      )
    ] })
  ] }), Ht = n.slice(0, r);
  return /* @__PURE__ */ d(
    mt,
    {
      "data-testid": "search-bar",
      onInputChange: k,
      onChange: le,
      options: Ht,
      inputValue: D,
      classes: {
        option: te.option,
        listbox: te.listbox
      },
      disableClearable: !0,
      open: E,
      filterOptions: (X) => X,
      autoHighlight: n.length === 1,
      onClose: me,
      onFocus: st,
      onBlur: At,
      onKeyDown: kt,
      fullWidth: !0,
      getOptionLabel: w || ((X) => X || ""),
      renderOption: (X) => /* @__PURE__ */ d(t, { option: X, inputValue: D }),
      freeSolo: !0,
      disableCloseOnSelect: P,
      PaperComponent: (X) => C ? /* @__PURE__ */ d(C, { ...X }) : /* @__PURE__ */ d(
        Wn,
        {
          loading: p,
          inputValue: D,
          searchedData: n,
          handleShowAllSearchResults: B,
          searchResultsLimit: r,
          showMore: a,
          showMoreLabel: i,
          noResultsText: c,
          classes: v,
          ...X
        }
      ),
      renderInput: (X) => /* @__PURE__ */ d(
        ue,
        {
          ...X,
          placeholder: l,
          inputRef: A,
          autoFocus: x,
          InputProps: {
            ...X.InputProps,
            startAdornment: /* @__PURE__ */ d(Pe, { position: "start", className: te.startAdornment, children: /* @__PURE__ */ d(m, { fontSize: "small", titleAccess: "searchIcon-start" }) }),
            endAdornment: zt,
            classes: {
              root: te.inputRoot,
              focused: te.inputFocused
            }
          }
        }
      )
    }
  );
};
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Ul() {
  return {
    accessor: (e, n) => typeof e == "function" ? {
      ...n,
      accessorFn: e
    } : {
      ...n,
      accessorKey: e
    },
    display: (e) => e,
    group: (e) => e
  };
}
function Z(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function W(e, n) {
  return (t) => {
    n.setState((o) => ({
      ...o,
      [e]: Z(t, o[e])
    }));
  };
}
function $e(e) {
  return e instanceof Function;
}
function Jn(e) {
  return Array.isArray(e) && e.every((n) => typeof n == "number");
}
function Yn(e, n) {
  const t = [], o = (s) => {
    s.forEach((l) => {
      t.push(l);
      const r = n(l);
      r != null && r.length && o(r);
    });
  };
  return o(e), t;
}
function $(e, n, t) {
  let o = [], s;
  return (l) => {
    let r;
    t.key && t.debug && (r = Date.now());
    const i = e(l);
    if (!(i.length !== o.length || i.some((p, f) => o[f] !== p)))
      return s;
    o = i;
    let c;
    if (t.key && t.debug && (c = Date.now()), s = n(...i), t == null || t.onChange == null || t.onChange(s), t.key && t.debug && t != null && t.debug()) {
      const p = Math.round((Date.now() - r) * 100) / 100, f = Math.round((Date.now() - c) * 100) / 100, g = f / 16, u = (m, C) => {
        for (m = String(m); m.length < C; )
          m = " " + m;
        return m;
      };
      console.info(`%c⏱ ${u(f, 5)} /${u(p, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * g, 120))}deg 100% 31%);`, t == null ? void 0 : t.key);
    }
    return s;
  };
}
function _(e, n, t, o) {
  return {
    debug: () => {
      var s;
      return (s = e == null ? void 0 : e.debugAll) != null ? s : e[n];
    },
    key: process.env.NODE_ENV === "development" && t,
    onChange: o
  };
}
function Zn(e, n, t, o) {
  const s = () => {
    var r;
    return (r = l.getValue()) != null ? r : e.options.renderFallbackValue;
  }, l = {
    id: `${n.id}_${t.id}`,
    row: n,
    column: t,
    getValue: () => n.getValue(o),
    renderValue: s,
    getContext: $(() => [e, t, n, l], (r, i, a, c) => ({
      table: r,
      column: i,
      row: a,
      cell: c,
      getValue: c.getValue,
      renderValue: c.renderValue
    }), _(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((r) => {
    r.createCell == null || r.createCell(l, t, n, e);
  }, {}), l;
}
function Qn(e, n, t, o) {
  var s, l;
  const i = {
    ...e._getDefaultColumnDef(),
    ...n
  }, a = i.accessorKey;
  let c = (s = (l = i.id) != null ? l : a ? a.replace(".", "_") : void 0) != null ? s : typeof i.header == "string" ? i.header : void 0, p;
  if (i.accessorFn ? p = i.accessorFn : a && (a.includes(".") ? p = (g) => {
    let u = g;
    for (const C of a.split(".")) {
      var m;
      u = (m = u) == null ? void 0 : m[C], process.env.NODE_ENV !== "production" && u === void 0 && console.warn(`"${C}" in deeply nested key "${a}" returned undefined.`);
    }
    return u;
  } : p = (g) => g[i.accessorKey]), !c)
    throw process.env.NODE_ENV !== "production" ? new Error(i.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let f = {
    id: `${String(c)}`,
    accessorFn: p,
    parent: o,
    depth: t,
    columnDef: i,
    columns: [],
    getFlatColumns: $(() => [!0], () => {
      var g;
      return [f, ...(g = f.columns) == null ? void 0 : g.flatMap((u) => u.getFlatColumns())];
    }, _(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: $(() => [e._getOrderColumnsFn()], (g) => {
      var u;
      if ((u = f.columns) != null && u.length) {
        let m = f.columns.flatMap((C) => C.getLeafColumns());
        return g(m);
      }
      return [f];
    }, _(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const g of e._features)
    g.createColumn == null || g.createColumn(f, e);
  return f;
}
const z = "debugHeaders";
function it(e, n, t) {
  var o;
  let l = {
    id: (o = t.id) != null ? o : n.id,
    column: n,
    index: t.index,
    isPlaceholder: !!t.isPlaceholder,
    placeholderId: t.placeholderId,
    depth: t.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const r = [], i = (a) => {
        a.subHeaders && a.subHeaders.length && a.subHeaders.map(i), r.push(a);
      };
      return i(l), r;
    },
    getContext: () => ({
      table: e,
      header: l,
      column: n
    })
  };
  return e._features.forEach((r) => {
    r.createHeader == null || r.createHeader(l, e);
  }), l;
}
const eo = {
  createTable: (e) => {
    e.getHeaderGroups = $(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, t, o, s) => {
      var l, r;
      const i = (l = o == null ? void 0 : o.map((f) => t.find((g) => g.id === f)).filter(Boolean)) != null ? l : [], a = (r = s == null ? void 0 : s.map((f) => t.find((g) => g.id === f)).filter(Boolean)) != null ? r : [], c = t.filter((f) => !(o != null && o.includes(f.id)) && !(s != null && s.includes(f.id)));
      return Ce(n, [...i, ...c, ...a], e);
    }, _(e.options, z, "getHeaderGroups")), e.getCenterHeaderGroups = $(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, t, o, s) => (t = t.filter((l) => !(o != null && o.includes(l.id)) && !(s != null && s.includes(l.id))), Ce(n, t, e, "center")), _(e.options, z, "getCenterHeaderGroups")), e.getLeftHeaderGroups = $(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (n, t, o) => {
      var s;
      const l = (s = o == null ? void 0 : o.map((r) => t.find((i) => i.id === r)).filter(Boolean)) != null ? s : [];
      return Ce(n, l, e, "left");
    }, _(e.options, z, "getLeftHeaderGroups")), e.getRightHeaderGroups = $(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (n, t, o) => {
      var s;
      const l = (s = o == null ? void 0 : o.map((r) => t.find((i) => i.id === r)).filter(Boolean)) != null ? s : [];
      return Ce(n, l, e, "right");
    }, _(e.options, z, "getRightHeaderGroups")), e.getFooterGroups = $(() => [e.getHeaderGroups()], (n) => [...n].reverse(), _(e.options, z, "getFooterGroups")), e.getLeftFooterGroups = $(() => [e.getLeftHeaderGroups()], (n) => [...n].reverse(), _(e.options, z, "getLeftFooterGroups")), e.getCenterFooterGroups = $(() => [e.getCenterHeaderGroups()], (n) => [...n].reverse(), _(e.options, z, "getCenterFooterGroups")), e.getRightFooterGroups = $(() => [e.getRightHeaderGroups()], (n) => [...n].reverse(), _(e.options, z, "getRightFooterGroups")), e.getFlatHeaders = $(() => [e.getHeaderGroups()], (n) => n.map((t) => t.headers).flat(), _(e.options, z, "getFlatHeaders")), e.getLeftFlatHeaders = $(() => [e.getLeftHeaderGroups()], (n) => n.map((t) => t.headers).flat(), _(e.options, z, "getLeftFlatHeaders")), e.getCenterFlatHeaders = $(() => [e.getCenterHeaderGroups()], (n) => n.map((t) => t.headers).flat(), _(e.options, z, "getCenterFlatHeaders")), e.getRightFlatHeaders = $(() => [e.getRightHeaderGroups()], (n) => n.map((t) => t.headers).flat(), _(e.options, z, "getRightFlatHeaders")), e.getCenterLeafHeaders = $(() => [e.getCenterFlatHeaders()], (n) => n.filter((t) => {
      var o;
      return !((o = t.subHeaders) != null && o.length);
    }), _(e.options, z, "getCenterLeafHeaders")), e.getLeftLeafHeaders = $(() => [e.getLeftFlatHeaders()], (n) => n.filter((t) => {
      var o;
      return !((o = t.subHeaders) != null && o.length);
    }), _(e.options, z, "getLeftLeafHeaders")), e.getRightLeafHeaders = $(() => [e.getRightFlatHeaders()], (n) => n.filter((t) => {
      var o;
      return !((o = t.subHeaders) != null && o.length);
    }), _(e.options, z, "getRightLeafHeaders")), e.getLeafHeaders = $(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (n, t, o) => {
      var s, l, r, i, a, c;
      return [...(s = (l = n[0]) == null ? void 0 : l.headers) != null ? s : [], ...(r = (i = t[0]) == null ? void 0 : i.headers) != null ? r : [], ...(a = (c = o[0]) == null ? void 0 : c.headers) != null ? a : []].map((p) => p.getLeafHeaders()).flat();
    }, _(e.options, z, "getLeafHeaders"));
  }
};
function Ce(e, n, t, o) {
  var s, l;
  let r = 0;
  const i = function(g, u) {
    u === void 0 && (u = 1), r = Math.max(r, u), g.filter((m) => m.getIsVisible()).forEach((m) => {
      var C;
      (C = m.columns) != null && C.length && i(m.columns, u + 1);
    }, 0);
  };
  i(e);
  let a = [];
  const c = (g, u) => {
    const m = {
      depth: u,
      id: [o, `${u}`].filter(Boolean).join("_"),
      headers: []
    }, C = [];
    g.forEach((h) => {
      const S = [...C].reverse()[0], w = h.column.depth === m.depth;
      let F, v = !1;
      if (w && h.column.parent ? F = h.column.parent : (F = h.column, v = !0), S && (S == null ? void 0 : S.column) === F)
        S.subHeaders.push(h);
      else {
        const P = it(t, F, {
          id: [o, u, F.id, h == null ? void 0 : h.id].filter(Boolean).join("_"),
          isPlaceholder: v,
          placeholderId: v ? `${C.filter((x) => x.column === F).length}` : void 0,
          depth: u,
          index: C.length
        });
        P.subHeaders.push(h), C.push(P);
      }
      m.headers.push(h), h.headerGroup = m;
    }), a.push(m), u > 0 && c(C, u - 1);
  }, p = n.map((g, u) => it(t, g, {
    depth: r,
    index: u
  }));
  c(p, r - 1), a.reverse();
  const f = (g) => g.filter((m) => m.column.getIsVisible()).map((m) => {
    let C = 0, h = 0, S = [0];
    m.subHeaders && m.subHeaders.length ? (S = [], f(m.subHeaders).forEach((F) => {
      let {
        colSpan: v,
        rowSpan: P
      } = F;
      C += v, S.push(P);
    })) : C = 1;
    const w = Math.min(...S);
    return h = h + w, m.colSpan = C, m.rowSpan = h, {
      colSpan: C,
      rowSpan: h
    };
  });
  return f((s = (l = a[0]) == null ? void 0 : l.headers) != null ? s : []), a;
}
const Qe = (e, n, t, o, s, l, r) => {
  let i = {
    id: n,
    index: o,
    original: t,
    depth: s,
    parentId: r,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (a) => {
      if (i._valuesCache.hasOwnProperty(a))
        return i._valuesCache[a];
      const c = e.getColumn(a);
      if (c != null && c.accessorFn)
        return i._valuesCache[a] = c.accessorFn(i.original, o), i._valuesCache[a];
    },
    getUniqueValues: (a) => {
      if (i._uniqueValuesCache.hasOwnProperty(a))
        return i._uniqueValuesCache[a];
      const c = e.getColumn(a);
      if (c != null && c.accessorFn)
        return c.columnDef.getUniqueValues ? (i._uniqueValuesCache[a] = c.columnDef.getUniqueValues(i.original, o), i._uniqueValuesCache[a]) : (i._uniqueValuesCache[a] = [i.getValue(a)], i._uniqueValuesCache[a]);
    },
    renderValue: (a) => {
      var c;
      return (c = i.getValue(a)) != null ? c : e.options.renderFallbackValue;
    },
    subRows: l ?? [],
    getLeafRows: () => Yn(i.subRows, (a) => a.subRows),
    getParentRow: () => i.parentId ? e.getRow(i.parentId, !0) : void 0,
    getParentRows: () => {
      let a = [], c = i;
      for (; ; ) {
        const p = c.getParentRow();
        if (!p)
          break;
        a.push(p), c = p;
      }
      return a.reverse();
    },
    getAllCells: $(() => [e.getAllLeafColumns()], (a) => a.map((c) => Zn(e, i, c, c.id)), _(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: $(() => [i.getAllCells()], (a) => a.reduce((c, p) => (c[p.column.id] = p, c), {}), _(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let a = 0; a < e._features.length; a++) {
    const c = e._features[a];
    c == null || c.createRow == null || c.createRow(i, e);
  }
  return i;
}, to = {
  createColumn: (e, n) => {
    e._getFacetedRowModel = n.options.getFacetedRowModel && n.options.getFacetedRowModel(n, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : n.getPreFilteredRowModel(), e._getFacetedUniqueValues = n.options.getFacetedUniqueValues && n.options.getFacetedUniqueValues(n, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = n.options.getFacetedMinMaxValues && n.options.getFacetedMinMaxValues(n, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, bt = (e, n, t) => {
  var o;
  const s = t.toLowerCase();
  return !!(!((o = e.getValue(n)) == null || (o = o.toString()) == null || (o = o.toLowerCase()) == null) && o.includes(s));
};
bt.autoRemove = (e) => J(e);
const Rt = (e, n, t) => {
  var o;
  return !!(!((o = e.getValue(n)) == null || (o = o.toString()) == null) && o.includes(t));
};
Rt.autoRemove = (e) => J(e);
const yt = (e, n, t) => {
  var o;
  return ((o = e.getValue(n)) == null || (o = o.toString()) == null ? void 0 : o.toLowerCase()) === (t == null ? void 0 : t.toLowerCase());
};
yt.autoRemove = (e) => J(e);
const Ft = (e, n, t) => {
  var o;
  return (o = e.getValue(n)) == null ? void 0 : o.includes(t);
};
Ft.autoRemove = (e) => J(e) || !(e != null && e.length);
const It = (e, n, t) => !t.some((o) => {
  var s;
  return !((s = e.getValue(n)) != null && s.includes(o));
});
It.autoRemove = (e) => J(e) || !(e != null && e.length);
const xt = (e, n, t) => t.some((o) => {
  var s;
  return (s = e.getValue(n)) == null ? void 0 : s.includes(o);
});
xt.autoRemove = (e) => J(e) || !(e != null && e.length);
const $t = (e, n, t) => e.getValue(n) === t;
$t.autoRemove = (e) => J(e);
const _t = (e, n, t) => e.getValue(n) == t;
_t.autoRemove = (e) => J(e);
const et = (e, n, t) => {
  let [o, s] = t;
  const l = e.getValue(n);
  return l >= o && l <= s;
};
et.resolveFilterValue = (e) => {
  let [n, t] = e, o = typeof n != "number" ? parseFloat(n) : n, s = typeof t != "number" ? parseFloat(t) : t, l = n === null || Number.isNaN(o) ? -1 / 0 : o, r = t === null || Number.isNaN(s) ? 1 / 0 : s;
  if (l > r) {
    const i = l;
    l = r, r = i;
  }
  return [l, r];
};
et.autoRemove = (e) => J(e) || J(e[0]) && J(e[1]);
const Y = {
  includesString: bt,
  includesStringSensitive: Rt,
  equalsString: yt,
  arrIncludes: Ft,
  arrIncludesAll: It,
  arrIncludesSome: xt,
  equals: $t,
  weakEquals: _t,
  inNumberRange: et
};
function J(e) {
  return e == null || e === "";
}
const no = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: W("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, n) => {
    e.getAutoFilterFn = () => {
      const t = n.getCoreRowModel().flatRows[0], o = t == null ? void 0 : t.getValue(e.id);
      return typeof o == "string" ? Y.includesString : typeof o == "number" ? Y.inNumberRange : typeof o == "boolean" || o !== null && typeof o == "object" ? Y.equals : Array.isArray(o) ? Y.arrIncludes : Y.weakEquals;
    }, e.getFilterFn = () => {
      var t, o;
      return $e(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (t = (o = n.options.filterFns) == null ? void 0 : o[e.columnDef.filterFn]) != null ? t : Y[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var t, o, s;
      return ((t = e.columnDef.enableColumnFilter) != null ? t : !0) && ((o = n.options.enableColumnFilters) != null ? o : !0) && ((s = n.options.enableFilters) != null ? s : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var t;
      return (t = n.getState().columnFilters) == null || (t = t.find((o) => o.id === e.id)) == null ? void 0 : t.value;
    }, e.getFilterIndex = () => {
      var t, o;
      return (t = (o = n.getState().columnFilters) == null ? void 0 : o.findIndex((s) => s.id === e.id)) != null ? t : -1;
    }, e.setFilterValue = (t) => {
      n.setColumnFilters((o) => {
        const s = e.getFilterFn(), l = o == null ? void 0 : o.find((p) => p.id === e.id), r = Z(t, l ? l.value : void 0);
        if (at(s, r, e)) {
          var i;
          return (i = o == null ? void 0 : o.filter((p) => p.id !== e.id)) != null ? i : [];
        }
        const a = {
          id: e.id,
          value: r
        };
        if (l) {
          var c;
          return (c = o == null ? void 0 : o.map((p) => p.id === e.id ? a : p)) != null ? c : [];
        }
        return o != null && o.length ? [...o, a] : [a];
      });
    };
  },
  createRow: (e, n) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (n) => {
      const t = e.getAllLeafColumns(), o = (s) => {
        var l;
        return (l = Z(n, s)) == null ? void 0 : l.filter((r) => {
          const i = t.find((a) => a.id === r.id);
          if (i) {
            const a = i.getFilterFn();
            if (at(a, r.value, i))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(o);
    }, e.resetColumnFilters = (n) => {
      var t, o;
      e.setColumnFilters(n ? [] : (t = (o = e.initialState) == null ? void 0 : o.columnFilters) != null ? t : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function at(e, n, t) {
  return (e && e.autoRemove ? e.autoRemove(n, t) : !1) || typeof n > "u" || typeof n == "string" && !n;
}
const oo = (e, n, t) => t.reduce((o, s) => {
  const l = s.getValue(e);
  return o + (typeof l == "number" ? l : 0);
}, 0), so = (e, n, t) => {
  let o;
  return t.forEach((s) => {
    const l = s.getValue(e);
    l != null && (o > l || o === void 0 && l >= l) && (o = l);
  }), o;
}, lo = (e, n, t) => {
  let o;
  return t.forEach((s) => {
    const l = s.getValue(e);
    l != null && (o < l || o === void 0 && l >= l) && (o = l);
  }), o;
}, ro = (e, n, t) => {
  let o, s;
  return t.forEach((l) => {
    const r = l.getValue(e);
    r != null && (o === void 0 ? r >= r && (o = s = r) : (o > r && (o = r), s < r && (s = r)));
  }), [o, s];
}, io = (e, n) => {
  let t = 0, o = 0;
  if (n.forEach((s) => {
    let l = s.getValue(e);
    l != null && (l = +l) >= l && (++t, o += l);
  }), t)
    return o / t;
}, ao = (e, n) => {
  if (!n.length)
    return;
  const t = n.map((l) => l.getValue(e));
  if (!Jn(t))
    return;
  if (t.length === 1)
    return t[0];
  const o = Math.floor(t.length / 2), s = t.sort((l, r) => l - r);
  return t.length % 2 !== 0 ? s[o] : (s[o - 1] + s[o]) / 2;
}, uo = (e, n) => Array.from(new Set(n.map((t) => t.getValue(e))).values()), co = (e, n) => new Set(n.map((t) => t.getValue(e))).size, go = (e, n) => n.length, _e = {
  sum: oo,
  min: so,
  max: lo,
  extent: ro,
  mean: io,
  median: ao,
  unique: uo,
  uniqueCount: co,
  count: go
}, po = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var n, t;
      return (n = (t = e.getValue()) == null || t.toString == null ? void 0 : t.toString()) != null ? n : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: W("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, n) => {
    e.toggleGrouping = () => {
      n.setGrouping((t) => t != null && t.includes(e.id) ? t.filter((o) => o !== e.id) : [...t ?? [], e.id]);
    }, e.getCanGroup = () => {
      var t, o;
      return ((t = e.columnDef.enableGrouping) != null ? t : !0) && ((o = n.options.enableGrouping) != null ? o : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var t;
      return (t = n.getState().grouping) == null ? void 0 : t.includes(e.id);
    }, e.getGroupedIndex = () => {
      var t;
      return (t = n.getState().grouping) == null ? void 0 : t.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const t = e.getCanGroup();
      return () => {
        t && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const t = n.getCoreRowModel().flatRows[0], o = t == null ? void 0 : t.getValue(e.id);
      if (typeof o == "number")
        return _e.sum;
      if (Object.prototype.toString.call(o) === "[object Date]")
        return _e.extent;
    }, e.getAggregationFn = () => {
      var t, o;
      if (!e)
        throw new Error();
      return $e(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (t = (o = n.options.aggregationFns) == null ? void 0 : o[e.columnDef.aggregationFn]) != null ? t : _e[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (n) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(n), e.resetGrouping = (n) => {
      var t, o;
      e.setGrouping(n ? [] : (t = (o = e.initialState) == null ? void 0 : o.grouping) != null ? t : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, n) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (t) => {
      if (e._groupingValuesCache.hasOwnProperty(t))
        return e._groupingValuesCache[t];
      const o = n.getColumn(t);
      return o != null && o.columnDef.getGroupingValue ? (e._groupingValuesCache[t] = o.columnDef.getGroupingValue(e.original), e._groupingValuesCache[t]) : e.getValue(t);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, n, t, o) => {
    e.getIsGrouped = () => n.getIsGrouped() && n.id === t.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && n.getIsGrouped(), e.getIsAggregated = () => {
      var s;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((s = t.subRows) != null && s.length);
    };
  }
};
function fo(e, n, t) {
  if (!(n != null && n.length) || !t)
    return e;
  const o = e.filter((l) => !n.includes(l.id));
  return t === "remove" ? o : [...n.map((l) => e.find((r) => r.id === l)).filter(Boolean), ...o];
}
const mo = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: W("columnOrder", e)
  }),
  createColumn: (e, n) => {
    e.getIndex = $((t) => [de(n, t)], (t) => t.findIndex((o) => o.id === e.id), _(n.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (t) => {
      var o;
      return ((o = de(n, t)[0]) == null ? void 0 : o.id) === e.id;
    }, e.getIsLastColumn = (t) => {
      var o;
      const s = de(n, t);
      return ((o = s[s.length - 1]) == null ? void 0 : o.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (n) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(n), e.resetColumnOrder = (n) => {
      var t;
      e.setColumnOrder(n ? [] : (t = e.initialState.columnOrder) != null ? t : []);
    }, e._getOrderColumnsFn = $(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (n, t, o) => (s) => {
      let l = [];
      if (!(n != null && n.length))
        l = s;
      else {
        const r = [...n], i = [...s];
        for (; i.length && r.length; ) {
          const a = r.shift(), c = i.findIndex((p) => p.id === a);
          c > -1 && l.push(i.splice(c, 1)[0]);
        }
        l = [...l, ...i];
      }
      return fo(l, t, o);
    }, _(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, Ge = () => ({
  left: [],
  right: []
}), Co = {
  getInitialState: (e) => ({
    columnPinning: Ge(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: W("columnPinning", e)
  }),
  createColumn: (e, n) => {
    e.pin = (t) => {
      const o = e.getLeafColumns().map((s) => s.id).filter(Boolean);
      n.setColumnPinning((s) => {
        var l, r;
        if (t === "right") {
          var i, a;
          return {
            left: ((i = s == null ? void 0 : s.left) != null ? i : []).filter((f) => !(o != null && o.includes(f))),
            right: [...((a = s == null ? void 0 : s.right) != null ? a : []).filter((f) => !(o != null && o.includes(f))), ...o]
          };
        }
        if (t === "left") {
          var c, p;
          return {
            left: [...((c = s == null ? void 0 : s.left) != null ? c : []).filter((f) => !(o != null && o.includes(f))), ...o],
            right: ((p = s == null ? void 0 : s.right) != null ? p : []).filter((f) => !(o != null && o.includes(f)))
          };
        }
        return {
          left: ((l = s == null ? void 0 : s.left) != null ? l : []).filter((f) => !(o != null && o.includes(f))),
          right: ((r = s == null ? void 0 : s.right) != null ? r : []).filter((f) => !(o != null && o.includes(f)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((o) => {
      var s, l, r;
      return ((s = o.columnDef.enablePinning) != null ? s : !0) && ((l = (r = n.options.enableColumnPinning) != null ? r : n.options.enablePinning) != null ? l : !0);
    }), e.getIsPinned = () => {
      const t = e.getLeafColumns().map((i) => i.id), {
        left: o,
        right: s
      } = n.getState().columnPinning, l = t.some((i) => o == null ? void 0 : o.includes(i)), r = t.some((i) => s == null ? void 0 : s.includes(i));
      return l ? "left" : r ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var t, o;
      const s = e.getIsPinned();
      return s ? (t = (o = n.getState().columnPinning) == null || (o = o[s]) == null ? void 0 : o.indexOf(e.id)) != null ? t : -1 : 0;
    };
  },
  createRow: (e, n) => {
    e.getCenterVisibleCells = $(() => [e._getAllVisibleCells(), n.getState().columnPinning.left, n.getState().columnPinning.right], (t, o, s) => {
      const l = [...o ?? [], ...s ?? []];
      return t.filter((r) => !l.includes(r.column.id));
    }, _(n.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = $(() => [e._getAllVisibleCells(), n.getState().columnPinning.left], (t, o) => (o ?? []).map((l) => t.find((r) => r.column.id === l)).filter(Boolean).map((l) => ({
      ...l,
      position: "left"
    })), _(n.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = $(() => [e._getAllVisibleCells(), n.getState().columnPinning.right], (t, o) => (o ?? []).map((l) => t.find((r) => r.column.id === l)).filter(Boolean).map((l) => ({
      ...l,
      position: "right"
    })), _(n.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (n) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(n), e.resetColumnPinning = (n) => {
      var t, o;
      return e.setColumnPinning(n ? Ge() : (t = (o = e.initialState) == null ? void 0 : o.columnPinning) != null ? t : Ge());
    }, e.getIsSomeColumnsPinned = (n) => {
      var t;
      const o = e.getState().columnPinning;
      if (!n) {
        var s, l;
        return !!((s = o.left) != null && s.length || (l = o.right) != null && l.length);
      }
      return !!((t = o[n]) != null && t.length);
    }, e.getLeftLeafColumns = $(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (n, t) => (t ?? []).map((o) => n.find((s) => s.id === o)).filter(Boolean), _(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = $(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (n, t) => (t ?? []).map((o) => n.find((s) => s.id === o)).filter(Boolean), _(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = $(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, t, o) => {
      const s = [...t ?? [], ...o ?? []];
      return n.filter((l) => !s.includes(l.id));
    }, _(e.options, "debugColumns", "getCenterLeafColumns"));
  }
}, he = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, Ve = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), ho = {
  getDefaultColumnDef: () => he,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: Ve(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: W("columnSizing", e),
    onColumnSizingInfoChange: W("columnSizingInfo", e)
  }),
  createColumn: (e, n) => {
    e.getSize = () => {
      var t, o, s;
      const l = n.getState().columnSizing[e.id];
      return Math.min(Math.max((t = e.columnDef.minSize) != null ? t : he.minSize, (o = l ?? e.columnDef.size) != null ? o : he.size), (s = e.columnDef.maxSize) != null ? s : he.maxSize);
    }, e.getStart = $((t) => [t, de(n, t), n.getState().columnSizing], (t, o) => o.slice(0, e.getIndex(t)).reduce((s, l) => s + l.getSize(), 0), _(n.options, "debugColumns", "getStart")), e.getAfter = $((t) => [t, de(n, t), n.getState().columnSizing], (t, o) => o.slice(e.getIndex(t) + 1).reduce((s, l) => s + l.getSize(), 0), _(n.options, "debugColumns", "getAfter")), e.resetSize = () => {
      n.setColumnSizing((t) => {
        let {
          [e.id]: o,
          ...s
        } = t;
        return s;
      });
    }, e.getCanResize = () => {
      var t, o;
      return ((t = e.columnDef.enableResizing) != null ? t : !0) && ((o = n.options.enableColumnResizing) != null ? o : !0);
    }, e.getIsResizing = () => n.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, n) => {
    e.getSize = () => {
      let t = 0;
      const o = (s) => {
        if (s.subHeaders.length)
          s.subHeaders.forEach(o);
        else {
          var l;
          t += (l = s.column.getSize()) != null ? l : 0;
        }
      };
      return o(e), t;
    }, e.getStart = () => {
      if (e.index > 0) {
        const t = e.headerGroup.headers[e.index - 1];
        return t.getStart() + t.getSize();
      }
      return 0;
    }, e.getResizeHandler = (t) => {
      const o = n.getColumn(e.column.id), s = o == null ? void 0 : o.getCanResize();
      return (l) => {
        if (!o || !s || (l.persist == null || l.persist(), Te(l) && l.touches && l.touches.length > 1))
          return;
        const r = e.getSize(), i = e ? e.getLeafHeaders().map((S) => [S.column.id, S.column.getSize()]) : [[o.id, o.getSize()]], a = Te(l) ? Math.round(l.touches[0].clientX) : l.clientX, c = {}, p = (S, w) => {
          typeof w == "number" && (n.setColumnSizingInfo((F) => {
            var v, P;
            const x = n.options.columnResizeDirection === "rtl" ? -1 : 1, G = (w - ((v = F == null ? void 0 : F.startOffset) != null ? v : 0)) * x, I = Math.max(G / ((P = F == null ? void 0 : F.startSize) != null ? P : 0), -0.999999);
            return F.columnSizingStart.forEach((A) => {
              let [D, E] = A;
              c[D] = Math.round(Math.max(E + E * I, 0) * 100) / 100;
            }), {
              ...F,
              deltaOffset: G,
              deltaPercentage: I
            };
          }), (n.options.columnResizeMode === "onChange" || S === "end") && n.setColumnSizing((F) => ({
            ...F,
            ...c
          })));
        }, f = (S) => p("move", S), g = (S) => {
          p("end", S), n.setColumnSizingInfo((w) => ({
            ...w,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, u = t || typeof document < "u" ? document : null, m = {
          moveHandler: (S) => f(S.clientX),
          upHandler: (S) => {
            u == null || u.removeEventListener("mousemove", m.moveHandler), u == null || u.removeEventListener("mouseup", m.upHandler), g(S.clientX);
          }
        }, C = {
          moveHandler: (S) => (S.cancelable && (S.preventDefault(), S.stopPropagation()), f(S.touches[0].clientX), !1),
          upHandler: (S) => {
            var w;
            u == null || u.removeEventListener("touchmove", C.moveHandler), u == null || u.removeEventListener("touchend", C.upHandler), S.cancelable && (S.preventDefault(), S.stopPropagation()), g((w = S.touches[0]) == null ? void 0 : w.clientX);
          }
        }, h = So() ? {
          passive: !1
        } : !1;
        Te(l) ? (u == null || u.addEventListener("touchmove", C.moveHandler, h), u == null || u.addEventListener("touchend", C.upHandler, h)) : (u == null || u.addEventListener("mousemove", m.moveHandler, h), u == null || u.addEventListener("mouseup", m.upHandler, h)), n.setColumnSizingInfo((S) => ({
          ...S,
          startOffset: a,
          startSize: r,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: i,
          isResizingColumn: o.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (n) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(n), e.setColumnSizingInfo = (n) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(n), e.resetColumnSizing = (n) => {
      var t;
      e.setColumnSizing(n ? {} : (t = e.initialState.columnSizing) != null ? t : {});
    }, e.resetHeaderSizeInfo = (n) => {
      var t;
      e.setColumnSizingInfo(n ? Ve() : (t = e.initialState.columnSizingInfo) != null ? t : Ve());
    }, e.getTotalSize = () => {
      var n, t;
      return (n = (t = e.getHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((o, s) => o + s.getSize(), 0)) != null ? n : 0;
    }, e.getLeftTotalSize = () => {
      var n, t;
      return (n = (t = e.getLeftHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((o, s) => o + s.getSize(), 0)) != null ? n : 0;
    }, e.getCenterTotalSize = () => {
      var n, t;
      return (n = (t = e.getCenterHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((o, s) => o + s.getSize(), 0)) != null ? n : 0;
    }, e.getRightTotalSize = () => {
      var n, t;
      return (n = (t = e.getRightHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((o, s) => o + s.getSize(), 0)) != null ? n : 0;
    };
  }
};
let Se = null;
function So() {
  if (typeof Se == "boolean")
    return Se;
  let e = !1;
  try {
    const n = {
      get passive() {
        return e = !0, !1;
      }
    }, t = () => {
    };
    window.addEventListener("test", t, n), window.removeEventListener("test", t);
  } catch {
    e = !1;
  }
  return Se = e, Se;
}
function Te(e) {
  return e.type === "touchstart";
}
const wo = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: W("columnVisibility", e)
  }),
  createColumn: (e, n) => {
    e.toggleVisibility = (t) => {
      e.getCanHide() && n.setColumnVisibility((o) => ({
        ...o,
        [e.id]: t ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var t, o;
      const s = e.columns;
      return (t = s.length ? s.some((l) => l.getIsVisible()) : (o = n.getState().columnVisibility) == null ? void 0 : o[e.id]) != null ? t : !0;
    }, e.getCanHide = () => {
      var t, o;
      return ((t = e.columnDef.enableHiding) != null ? t : !0) && ((o = n.options.enableHiding) != null ? o : !0);
    }, e.getToggleVisibilityHandler = () => (t) => {
      e.toggleVisibility == null || e.toggleVisibility(t.target.checked);
    };
  },
  createRow: (e, n) => {
    e._getAllVisibleCells = $(() => [e.getAllCells(), n.getState().columnVisibility], (t) => t.filter((o) => o.column.getIsVisible()), _(n.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = $(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (t, o, s) => [...t, ...o, ...s], _(n.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const n = (t, o) => $(() => [o(), o().filter((s) => s.getIsVisible()).map((s) => s.id).join("_")], (s) => s.filter((l) => l.getIsVisible == null ? void 0 : l.getIsVisible()), _(e.options, "debugColumns", t));
    e.getVisibleFlatColumns = n("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = n("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = n("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = n("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = n("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (t) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(t), e.resetColumnVisibility = (t) => {
      var o;
      e.setColumnVisibility(t ? {} : (o = e.initialState.columnVisibility) != null ? o : {});
    }, e.toggleAllColumnsVisible = (t) => {
      var o;
      t = (o = t) != null ? o : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((s, l) => ({
        ...s,
        [l.id]: t || !(l.getCanHide != null && l.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((t) => !(t.getIsVisible != null && t.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((t) => t.getIsVisible == null ? void 0 : t.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (t) => {
      var o;
      e.toggleAllColumnsVisible((o = t.target) == null ? void 0 : o.checked);
    };
  }
};
function de(e, n) {
  return n ? n === "center" ? e.getCenterVisibleLeafColumns() : n === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const Po = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, vo = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: W("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (n) => {
      var t;
      const o = (t = e.getCoreRowModel().flatRows[0]) == null || (t = t._getAllCellsByColumnId()[n.id]) == null ? void 0 : t.getValue();
      return typeof o == "string" || typeof o == "number";
    }
  }),
  createColumn: (e, n) => {
    e.getCanGlobalFilter = () => {
      var t, o, s, l;
      return ((t = e.columnDef.enableGlobalFilter) != null ? t : !0) && ((o = n.options.enableGlobalFilter) != null ? o : !0) && ((s = n.options.enableFilters) != null ? s : !0) && ((l = n.options.getColumnCanGlobalFilter == null ? void 0 : n.options.getColumnCanGlobalFilter(e)) != null ? l : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => Y.includesString, e.getGlobalFilterFn = () => {
      var n, t;
      const {
        globalFilterFn: o
      } = e.options;
      return $e(o) ? o : o === "auto" ? e.getGlobalAutoFilterFn() : (n = (t = e.options.filterFns) == null ? void 0 : t[o]) != null ? n : Y[o];
    }, e.setGlobalFilter = (n) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(n);
    }, e.resetGlobalFilter = (n) => {
      e.setGlobalFilter(n ? void 0 : e.initialState.globalFilter);
    };
  }
}, bo = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: W("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let n = !1, t = !1;
    e._autoResetExpanded = () => {
      var o, s;
      if (!n) {
        e._queue(() => {
          n = !0;
        });
        return;
      }
      if ((o = (s = e.options.autoResetAll) != null ? s : e.options.autoResetExpanded) != null ? o : !e.options.manualExpanding) {
        if (t)
          return;
        t = !0, e._queue(() => {
          e.resetExpanded(), t = !1;
        });
      }
    }, e.setExpanded = (o) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(o), e.toggleAllRowsExpanded = (o) => {
      o ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (o) => {
      var s, l;
      e.setExpanded(o ? {} : (s = (l = e.initialState) == null ? void 0 : l.expanded) != null ? s : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((o) => o.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (o) => {
      o.persist == null || o.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const o = e.getState().expanded;
      return o === !0 || Object.values(o).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const o = e.getState().expanded;
      return typeof o == "boolean" ? o === !0 : !(!Object.keys(o).length || e.getRowModel().flatRows.some((s) => !s.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let o = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((l) => {
        const r = l.split(".");
        o = Math.max(o, r.length);
      }), o;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, n) => {
    e.toggleExpanded = (t) => {
      n.setExpanded((o) => {
        var s;
        const l = o === !0 ? !0 : !!(o != null && o[e.id]);
        let r = {};
        if (o === !0 ? Object.keys(n.getRowModel().rowsById).forEach((i) => {
          r[i] = !0;
        }) : r = o, t = (s = t) != null ? s : !l, !l && t)
          return {
            ...r,
            [e.id]: !0
          };
        if (l && !t) {
          const {
            [e.id]: i,
            ...a
          } = r;
          return a;
        }
        return o;
      });
    }, e.getIsExpanded = () => {
      var t;
      const o = n.getState().expanded;
      return !!((t = n.options.getIsRowExpanded == null ? void 0 : n.options.getIsRowExpanded(e)) != null ? t : o === !0 || o != null && o[e.id]);
    }, e.getCanExpand = () => {
      var t, o, s;
      return (t = n.options.getRowCanExpand == null ? void 0 : n.options.getRowCanExpand(e)) != null ? t : ((o = n.options.enableExpanding) != null ? o : !0) && !!((s = e.subRows) != null && s.length);
    }, e.getIsAllParentsExpanded = () => {
      let t = !0, o = e;
      for (; t && o.parentId; )
        o = n.getRow(o.parentId, !0), t = o.getIsExpanded();
      return t;
    }, e.getToggleExpandedHandler = () => {
      const t = e.getCanExpand();
      return () => {
        t && e.toggleExpanded();
      };
    };
  }
}, ke = 0, Be = 10, Me = () => ({
  pageIndex: ke,
  pageSize: Be
}), Ro = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...Me(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: W("pagination", e)
  }),
  createTable: (e) => {
    let n = !1, t = !1;
    e._autoResetPageIndex = () => {
      var o, s;
      if (!n) {
        e._queue(() => {
          n = !0;
        });
        return;
      }
      if ((o = (s = e.options.autoResetAll) != null ? s : e.options.autoResetPageIndex) != null ? o : !e.options.manualPagination) {
        if (t)
          return;
        t = !0, e._queue(() => {
          e.resetPageIndex(), t = !1;
        });
      }
    }, e.setPagination = (o) => {
      const s = (l) => Z(o, l);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(s);
    }, e.resetPagination = (o) => {
      var s;
      e.setPagination(o ? Me() : (s = e.initialState.pagination) != null ? s : Me());
    }, e.setPageIndex = (o) => {
      e.setPagination((s) => {
        let l = Z(o, s.pageIndex);
        const r = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return l = Math.max(0, Math.min(l, r)), {
          ...s,
          pageIndex: l
        };
      });
    }, e.resetPageIndex = (o) => {
      var s, l;
      e.setPageIndex(o ? ke : (s = (l = e.initialState) == null || (l = l.pagination) == null ? void 0 : l.pageIndex) != null ? s : ke);
    }, e.resetPageSize = (o) => {
      var s, l;
      e.setPageSize(o ? Be : (s = (l = e.initialState) == null || (l = l.pagination) == null ? void 0 : l.pageSize) != null ? s : Be);
    }, e.setPageSize = (o) => {
      e.setPagination((s) => {
        const l = Math.max(1, Z(o, s.pageSize)), r = s.pageSize * s.pageIndex, i = Math.floor(r / l);
        return {
          ...s,
          pageIndex: i,
          pageSize: l
        };
      });
    }, e.setPageCount = (o) => e.setPagination((s) => {
      var l;
      let r = Z(o, (l = e.options.pageCount) != null ? l : -1);
      return typeof r == "number" && (r = Math.max(-1, r)), {
        ...s,
        pageCount: r
      };
    }), e.getPageOptions = $(() => [e.getPageCount()], (o) => {
      let s = [];
      return o && o > 0 && (s = [...new Array(o)].fill(null).map((l, r) => r)), s;
    }, _(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: o
      } = e.getState().pagination, s = e.getPageCount();
      return s === -1 ? !0 : s === 0 ? !1 : o < s - 1;
    }, e.previousPage = () => e.setPageIndex((o) => o - 1), e.nextPage = () => e.setPageIndex((o) => o + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var o;
      return (o = e.options.pageCount) != null ? o : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var o;
      return (o = e.options.rowCount) != null ? o : e.getPrePaginationRowModel().rows.length;
    };
  }
}, De = () => ({
  top: [],
  bottom: []
}), yo = {
  getInitialState: (e) => ({
    rowPinning: De(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: W("rowPinning", e)
  }),
  createRow: (e, n) => {
    e.pin = (t, o, s) => {
      const l = o ? e.getLeafRows().map((a) => {
        let {
          id: c
        } = a;
        return c;
      }) : [], r = s ? e.getParentRows().map((a) => {
        let {
          id: c
        } = a;
        return c;
      }) : [], i = /* @__PURE__ */ new Set([...r, e.id, ...l]);
      n.setRowPinning((a) => {
        var c, p;
        if (t === "bottom") {
          var f, g;
          return {
            top: ((f = a == null ? void 0 : a.top) != null ? f : []).filter((C) => !(i != null && i.has(C))),
            bottom: [...((g = a == null ? void 0 : a.bottom) != null ? g : []).filter((C) => !(i != null && i.has(C))), ...Array.from(i)]
          };
        }
        if (t === "top") {
          var u, m;
          return {
            top: [...((u = a == null ? void 0 : a.top) != null ? u : []).filter((C) => !(i != null && i.has(C))), ...Array.from(i)],
            bottom: ((m = a == null ? void 0 : a.bottom) != null ? m : []).filter((C) => !(i != null && i.has(C)))
          };
        }
        return {
          top: ((c = a == null ? void 0 : a.top) != null ? c : []).filter((C) => !(i != null && i.has(C))),
          bottom: ((p = a == null ? void 0 : a.bottom) != null ? p : []).filter((C) => !(i != null && i.has(C)))
        };
      });
    }, e.getCanPin = () => {
      var t;
      const {
        enableRowPinning: o,
        enablePinning: s
      } = n.options;
      return typeof o == "function" ? o(e) : (t = o ?? s) != null ? t : !0;
    }, e.getIsPinned = () => {
      const t = [e.id], {
        top: o,
        bottom: s
      } = n.getState().rowPinning, l = t.some((i) => o == null ? void 0 : o.includes(i)), r = t.some((i) => s == null ? void 0 : s.includes(i));
      return l ? "top" : r ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var t, o;
      const s = e.getIsPinned();
      if (!s)
        return -1;
      const l = (t = n._getPinnedRows(s)) == null ? void 0 : t.map((r) => {
        let {
          id: i
        } = r;
        return i;
      });
      return (o = l == null ? void 0 : l.indexOf(e.id)) != null ? o : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (n) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(n), e.resetRowPinning = (n) => {
      var t, o;
      return e.setRowPinning(n ? De() : (t = (o = e.initialState) == null ? void 0 : o.rowPinning) != null ? t : De());
    }, e.getIsSomeRowsPinned = (n) => {
      var t;
      const o = e.getState().rowPinning;
      if (!n) {
        var s, l;
        return !!((s = o.top) != null && s.length || (l = o.bottom) != null && l.length);
      }
      return !!((t = o[n]) != null && t.length);
    }, e._getPinnedRows = $((n) => [e.getRowModel().rows, e.getState().rowPinning[n], n], (n, t, o) => {
      var s;
      return ((s = e.options.keepPinnedRows) == null || s ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (t ?? []).map((r) => {
          const i = e.getRow(r, !0);
          return i.getIsAllParentsExpanded() ? i : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (t ?? []).map((r) => n.find((i) => i.id === r))
      )).filter(Boolean).map((r) => ({
        ...r,
        position: o
      }));
    }, _(e.options, "debugRows", "_getPinnedRows")), e.getTopRows = () => e._getPinnedRows("top"), e.getBottomRows = () => e._getPinnedRows("bottom"), e.getCenterRows = $(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (n, t, o) => {
      const s = /* @__PURE__ */ new Set([...t ?? [], ...o ?? []]);
      return n.filter((l) => !s.has(l.id));
    }, _(e.options, "debugRows", "getCenterRows"));
  }
}, Fo = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: W("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (n) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(n), e.resetRowSelection = (n) => {
      var t;
      return e.setRowSelection(n ? {} : (t = e.initialState.rowSelection) != null ? t : {});
    }, e.toggleAllRowsSelected = (n) => {
      e.setRowSelection((t) => {
        n = typeof n < "u" ? n : !e.getIsAllRowsSelected();
        const o = {
          ...t
        }, s = e.getPreGroupedRowModel().flatRows;
        return n ? s.forEach((l) => {
          l.getCanSelect() && (o[l.id] = !0);
        }) : s.forEach((l) => {
          delete o[l.id];
        }), o;
      });
    }, e.toggleAllPageRowsSelected = (n) => e.setRowSelection((t) => {
      const o = typeof n < "u" ? n : !e.getIsAllPageRowsSelected(), s = {
        ...t
      };
      return e.getRowModel().rows.forEach((l) => {
        ze(s, l.id, o, !0, e);
      }), s;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = $(() => [e.getState().rowSelection, e.getCoreRowModel()], (n, t) => Object.keys(n).length ? Le(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, _(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = $(() => [e.getState().rowSelection, e.getFilteredRowModel()], (n, t) => Object.keys(n).length ? Le(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, _(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = $(() => [e.getState().rowSelection, e.getSortedRowModel()], (n, t) => Object.keys(n).length ? Le(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, _(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const n = e.getFilteredRowModel().flatRows, {
        rowSelection: t
      } = e.getState();
      let o = !!(n.length && Object.keys(t).length);
      return o && n.some((s) => s.getCanSelect() && !t[s.id]) && (o = !1), o;
    }, e.getIsAllPageRowsSelected = () => {
      const n = e.getPaginationRowModel().flatRows.filter((s) => s.getCanSelect()), {
        rowSelection: t
      } = e.getState();
      let o = !!n.length;
      return o && n.some((s) => !t[s.id]) && (o = !1), o;
    }, e.getIsSomeRowsSelected = () => {
      var n;
      const t = Object.keys((n = e.getState().rowSelection) != null ? n : {}).length;
      return t > 0 && t < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const n = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : n.filter((t) => t.getCanSelect()).some((t) => t.getIsSelected() || t.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (n) => {
      e.toggleAllRowsSelected(n.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (n) => {
      e.toggleAllPageRowsSelected(n.target.checked);
    };
  },
  createRow: (e, n) => {
    e.toggleSelected = (t, o) => {
      const s = e.getIsSelected();
      n.setRowSelection((l) => {
        var r;
        if (t = typeof t < "u" ? t : !s, e.getCanSelect() && s === t)
          return l;
        const i = {
          ...l
        };
        return ze(i, e.id, t, (r = o == null ? void 0 : o.selectChildren) != null ? r : !0, n), i;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: t
      } = n.getState();
      return tt(e, t);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: t
      } = n.getState();
      return He(e, t) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: t
      } = n.getState();
      return He(e, t) === "all";
    }, e.getCanSelect = () => {
      var t;
      return typeof n.options.enableRowSelection == "function" ? n.options.enableRowSelection(e) : (t = n.options.enableRowSelection) != null ? t : !0;
    }, e.getCanSelectSubRows = () => {
      var t;
      return typeof n.options.enableSubRowSelection == "function" ? n.options.enableSubRowSelection(e) : (t = n.options.enableSubRowSelection) != null ? t : !0;
    }, e.getCanMultiSelect = () => {
      var t;
      return typeof n.options.enableMultiRowSelection == "function" ? n.options.enableMultiRowSelection(e) : (t = n.options.enableMultiRowSelection) != null ? t : !0;
    }, e.getToggleSelectedHandler = () => {
      const t = e.getCanSelect();
      return (o) => {
        var s;
        t && e.toggleSelected((s = o.target) == null ? void 0 : s.checked);
      };
    };
  }
}, ze = (e, n, t, o, s) => {
  var l;
  const r = s.getRow(n, !0);
  t ? (r.getCanMultiSelect() || Object.keys(e).forEach((i) => delete e[i]), r.getCanSelect() && (e[n] = !0)) : delete e[n], o && (l = r.subRows) != null && l.length && r.getCanSelectSubRows() && r.subRows.forEach((i) => ze(e, i.id, t, o, s));
};
function Le(e, n) {
  const t = e.getState().rowSelection, o = [], s = {}, l = function(r, i) {
    return r.map((a) => {
      var c;
      const p = tt(a, t);
      if (p && (o.push(a), s[a.id] = a), (c = a.subRows) != null && c.length && (a = {
        ...a,
        subRows: l(a.subRows)
      }), p)
        return a;
    }).filter(Boolean);
  };
  return {
    rows: l(n.rows),
    flatRows: o,
    rowsById: s
  };
}
function tt(e, n) {
  var t;
  return (t = n[e.id]) != null ? t : !1;
}
function He(e, n, t) {
  var o;
  if (!((o = e.subRows) != null && o.length))
    return !1;
  let s = !0, l = !1;
  return e.subRows.forEach((r) => {
    if (!(l && !s) && (r.getCanSelect() && (tt(r, n) ? l = !0 : s = !1), r.subRows && r.subRows.length)) {
      const i = He(r, n);
      i === "all" ? l = !0 : (i === "some" && (l = !0), s = !1);
    }
  }), s ? "all" : l ? "some" : !1;
}
const Ne = /([0-9]+)/gm, Io = (e, n, t) => Gt(Q(e.getValue(t)).toLowerCase(), Q(n.getValue(t)).toLowerCase()), xo = (e, n, t) => Gt(Q(e.getValue(t)), Q(n.getValue(t))), $o = (e, n, t) => nt(Q(e.getValue(t)).toLowerCase(), Q(n.getValue(t)).toLowerCase()), _o = (e, n, t) => nt(Q(e.getValue(t)), Q(n.getValue(t))), Go = (e, n, t) => {
  const o = e.getValue(t), s = n.getValue(t);
  return o > s ? 1 : o < s ? -1 : 0;
}, Vo = (e, n, t) => nt(e.getValue(t), n.getValue(t));
function nt(e, n) {
  return e === n ? 0 : e > n ? 1 : -1;
}
function Q(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function Gt(e, n) {
  const t = e.split(Ne).filter(Boolean), o = n.split(Ne).filter(Boolean);
  for (; t.length && o.length; ) {
    const s = t.shift(), l = o.shift(), r = parseInt(s, 10), i = parseInt(l, 10), a = [r, i].sort();
    if (isNaN(a[0])) {
      if (s > l)
        return 1;
      if (l > s)
        return -1;
      continue;
    }
    if (isNaN(a[1]))
      return isNaN(r) ? -1 : 1;
    if (r > i)
      return 1;
    if (i > r)
      return -1;
  }
  return t.length - o.length;
}
const ce = {
  alphanumeric: Io,
  alphanumericCaseSensitive: xo,
  text: $o,
  textCaseSensitive: _o,
  datetime: Go,
  basic: Vo
}, To = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: W("sorting", e),
    isMultiSortEvent: (n) => n.shiftKey
  }),
  createColumn: (e, n) => {
    e.getAutoSortingFn = () => {
      const t = n.getFilteredRowModel().flatRows.slice(10);
      let o = !1;
      for (const s of t) {
        const l = s == null ? void 0 : s.getValue(e.id);
        if (Object.prototype.toString.call(l) === "[object Date]")
          return ce.datetime;
        if (typeof l == "string" && (o = !0, l.split(Ne).length > 1))
          return ce.alphanumeric;
      }
      return o ? ce.text : ce.basic;
    }, e.getAutoSortDir = () => {
      const t = n.getFilteredRowModel().flatRows[0];
      return typeof (t == null ? void 0 : t.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var t, o;
      if (!e)
        throw new Error();
      return $e(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (t = (o = n.options.sortingFns) == null ? void 0 : o[e.columnDef.sortingFn]) != null ? t : ce[e.columnDef.sortingFn];
    }, e.toggleSorting = (t, o) => {
      const s = e.getNextSortingOrder(), l = typeof t < "u" && t !== null;
      n.setSorting((r) => {
        const i = r == null ? void 0 : r.find((u) => u.id === e.id), a = r == null ? void 0 : r.findIndex((u) => u.id === e.id);
        let c = [], p, f = l ? t : s === "desc";
        if (r != null && r.length && e.getCanMultiSort() && o ? i ? p = "toggle" : p = "add" : r != null && r.length && a !== r.length - 1 ? p = "replace" : i ? p = "toggle" : p = "replace", p === "toggle" && (l || s || (p = "remove")), p === "add") {
          var g;
          c = [...r, {
            id: e.id,
            desc: f
          }], c.splice(0, c.length - ((g = n.options.maxMultiSortColCount) != null ? g : Number.MAX_SAFE_INTEGER));
        } else
          p === "toggle" ? c = r.map((u) => u.id === e.id ? {
            ...u,
            desc: f
          } : u) : p === "remove" ? c = r.filter((u) => u.id !== e.id) : c = [{
            id: e.id,
            desc: f
          }];
        return c;
      });
    }, e.getFirstSortDir = () => {
      var t, o;
      return ((t = (o = e.columnDef.sortDescFirst) != null ? o : n.options.sortDescFirst) != null ? t : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (t) => {
      var o, s;
      const l = e.getFirstSortDir(), r = e.getIsSorted();
      return r ? r !== l && ((o = n.options.enableSortingRemoval) == null || o) && // If enableSortRemove, enable in general
      (!(t && (s = n.options.enableMultiRemove) != null) || s) ? !1 : r === "desc" ? "asc" : "desc" : l;
    }, e.getCanSort = () => {
      var t, o;
      return ((t = e.columnDef.enableSorting) != null ? t : !0) && ((o = n.options.enableSorting) != null ? o : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var t, o;
      return (t = (o = e.columnDef.enableMultiSort) != null ? o : n.options.enableMultiSort) != null ? t : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var t;
      const o = (t = n.getState().sorting) == null ? void 0 : t.find((s) => s.id === e.id);
      return o ? o.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var t, o;
      return (t = (o = n.getState().sorting) == null ? void 0 : o.findIndex((s) => s.id === e.id)) != null ? t : -1;
    }, e.clearSorting = () => {
      n.setSorting((t) => t != null && t.length ? t.filter((o) => o.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const t = e.getCanSort();
      return (o) => {
        t && (o.persist == null || o.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? n.options.isMultiSortEvent == null ? void 0 : n.options.isMultiSortEvent(o) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (n) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(n), e.resetSorting = (n) => {
      var t, o;
      e.setSorting(n ? [] : (t = (o = e.initialState) == null ? void 0 : o.sorting) != null ? t : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, Mo = [
  eo,
  wo,
  mo,
  Co,
  to,
  no,
  Po,
  //depends on ColumnFaceting
  vo,
  //depends on ColumnFiltering
  To,
  po,
  //depends on RowSorting
  bo,
  Ro,
  yo,
  Fo,
  ho
];
function Do(e) {
  var n, t;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const o = [...Mo, ...(n = e._features) != null ? n : []];
  let s = {
    _features: o
  };
  const l = s._features.reduce((g, u) => Object.assign(g, u.getDefaultOptions == null ? void 0 : u.getDefaultOptions(s)), {}), r = (g) => s.options.mergeOptions ? s.options.mergeOptions(l, g) : {
    ...l,
    ...g
  };
  let a = {
    ...{},
    ...(t = e.initialState) != null ? t : {}
  };
  s._features.forEach((g) => {
    var u;
    a = (u = g.getInitialState == null ? void 0 : g.getInitialState(a)) != null ? u : a;
  });
  const c = [];
  let p = !1;
  const f = {
    _features: o,
    options: {
      ...l,
      ...e
    },
    initialState: a,
    _queue: (g) => {
      c.push(g), p || (p = !0, Promise.resolve().then(() => {
        for (; c.length; )
          c.shift()();
        p = !1;
      }).catch((u) => setTimeout(() => {
        throw u;
      })));
    },
    reset: () => {
      s.setState(s.initialState);
    },
    setOptions: (g) => {
      const u = Z(g, s.options);
      s.options = r(u);
    },
    getState: () => s.options.state,
    setState: (g) => {
      s.options.onStateChange == null || s.options.onStateChange(g);
    },
    _getRowId: (g, u, m) => {
      var C;
      return (C = s.options.getRowId == null ? void 0 : s.options.getRowId(g, u, m)) != null ? C : `${m ? [m.id, u].join(".") : u}`;
    },
    getCoreRowModel: () => (s._getCoreRowModel || (s._getCoreRowModel = s.options.getCoreRowModel(s)), s._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => s.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (g, u) => {
      let m = (u ? s.getPrePaginationRowModel() : s.getRowModel()).rowsById[g];
      if (!m && (m = s.getCoreRowModel().rowsById[g], !m))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${g}`) : new Error();
      return m;
    },
    _getDefaultColumnDef: $(() => [s.options.defaultColumn], (g) => {
      var u;
      return g = (u = g) != null ? u : {}, {
        header: (m) => {
          const C = m.header.column.columnDef;
          return C.accessorKey ? C.accessorKey : C.accessorFn ? C.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (m) => {
          var C, h;
          return (C = (h = m.renderValue()) == null || h.toString == null ? void 0 : h.toString()) != null ? C : null;
        },
        ...s._features.reduce((m, C) => Object.assign(m, C.getDefaultColumnDef == null ? void 0 : C.getDefaultColumnDef()), {}),
        ...g
      };
    }, _(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => s.options.columns,
    getAllColumns: $(() => [s._getColumnDefs()], (g) => {
      const u = function(m, C, h) {
        return h === void 0 && (h = 0), m.map((S) => {
          const w = Qn(s, S, h, C), F = S;
          return w.columns = F.columns ? u(F.columns, w, h + 1) : [], w;
        });
      };
      return u(g);
    }, _(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: $(() => [s.getAllColumns()], (g) => g.flatMap((u) => u.getFlatColumns()), _(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: $(() => [s.getAllFlatColumns()], (g) => g.reduce((u, m) => (u[m.id] = m, u), {}), _(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: $(() => [s.getAllColumns(), s._getOrderColumnsFn()], (g, u) => {
      let m = g.flatMap((C) => C.getLeafColumns());
      return u(m);
    }, _(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (g) => {
      const u = s._getAllFlatColumnsById()[g];
      return process.env.NODE_ENV !== "production" && !u && console.error(`[Table] Column with id '${g}' does not exist.`), u;
    }
  };
  Object.assign(s, f);
  for (let g = 0; g < s._features.length; g++) {
    const u = s._features[g];
    u == null || u.createTable == null || u.createTable(s);
  }
  return s;
}
function Lo() {
  return (e) => $(() => [e.options.data], (n) => {
    const t = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, o = function(s, l, r) {
      l === void 0 && (l = 0);
      const i = [];
      for (let c = 0; c < s.length; c++) {
        const p = Qe(e, e._getRowId(s[c], c, r), s[c], c, l, void 0, r == null ? void 0 : r.id);
        if (t.flatRows.push(p), t.rowsById[p.id] = p, i.push(p), e.options.getSubRows) {
          var a;
          p.originalSubRows = e.options.getSubRows(s[c], c), (a = p.originalSubRows) != null && a.length && (p.subRows = o(p.originalSubRows, l + 1, p));
        }
      }
      return i;
    };
    return t.rows = o(n), t;
  }, _(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function Eo(e) {
  const n = [], t = (o) => {
    var s;
    n.push(o), (s = o.subRows) != null && s.length && o.getIsExpanded() && o.subRows.forEach(t);
  };
  return e.rows.forEach(t), {
    rows: n,
    flatRows: e.flatRows,
    rowsById: e.rowsById
  };
}
function Ao(e, n, t) {
  return t.options.filterFromLeafRows ? ko(e, n, t) : Bo(e, n, t);
}
function ko(e, n, t) {
  var o;
  const s = [], l = {}, r = (o = t.options.maxLeafRowFilterDepth) != null ? o : 100, i = function(a, c) {
    c === void 0 && (c = 0);
    const p = [];
    for (let g = 0; g < a.length; g++) {
      var f;
      let u = a[g];
      const m = Qe(t, u.id, u.original, u.index, u.depth, void 0, u.parentId);
      if (m.columnFilters = u.columnFilters, (f = u.subRows) != null && f.length && c < r) {
        if (m.subRows = i(u.subRows, c + 1), u = m, n(u) && !m.subRows.length) {
          p.push(u), l[u.id] = u, s.push(u);
          continue;
        }
        if (n(u) || m.subRows.length) {
          p.push(u), l[u.id] = u, s.push(u);
          continue;
        }
      } else
        u = m, n(u) && (p.push(u), l[u.id] = u, s.push(u));
    }
    return p;
  };
  return {
    rows: i(e),
    flatRows: s,
    rowsById: l
  };
}
function Bo(e, n, t) {
  var o;
  const s = [], l = {}, r = (o = t.options.maxLeafRowFilterDepth) != null ? o : 100, i = function(a, c) {
    c === void 0 && (c = 0);
    const p = [];
    for (let g = 0; g < a.length; g++) {
      let u = a[g];
      if (n(u)) {
        var f;
        if ((f = u.subRows) != null && f.length && c < r) {
          const C = Qe(t, u.id, u.original, u.index, u.depth, void 0, u.parentId);
          C.subRows = i(u.subRows, c + 1), u = C;
        }
        p.push(u), s.push(u), l[u.id] = u;
      }
    }
    return p;
  };
  return {
    rows: i(e),
    flatRows: s,
    rowsById: l
  };
}
function zo() {
  return (e) => $(() => [e.getPreFilteredRowModel(), e.getState().columnFilters, e.getState().globalFilter], (n, t, o) => {
    if (!n.rows.length || !(t != null && t.length) && !o) {
      for (let g = 0; g < n.flatRows.length; g++)
        n.flatRows[g].columnFilters = {}, n.flatRows[g].columnFiltersMeta = {};
      return n;
    }
    const s = [], l = [];
    (t ?? []).forEach((g) => {
      var u;
      const m = e.getColumn(g.id);
      if (!m)
        return;
      const C = m.getFilterFn();
      if (!C) {
        process.env.NODE_ENV !== "production" && console.warn(`Could not find a valid 'column.filterFn' for column with the ID: ${m.id}.`);
        return;
      }
      s.push({
        id: g.id,
        filterFn: C,
        resolvedValue: (u = C.resolveFilterValue == null ? void 0 : C.resolveFilterValue(g.value)) != null ? u : g.value
      });
    });
    const r = t.map((g) => g.id), i = e.getGlobalFilterFn(), a = e.getAllLeafColumns().filter((g) => g.getCanGlobalFilter());
    o && i && a.length && (r.push("__global__"), a.forEach((g) => {
      var u;
      l.push({
        id: g.id,
        filterFn: i,
        resolvedValue: (u = i.resolveFilterValue == null ? void 0 : i.resolveFilterValue(o)) != null ? u : o
      });
    }));
    let c, p;
    for (let g = 0; g < n.flatRows.length; g++) {
      const u = n.flatRows[g];
      if (u.columnFilters = {}, s.length)
        for (let m = 0; m < s.length; m++) {
          c = s[m];
          const C = c.id;
          u.columnFilters[C] = c.filterFn(u, C, c.resolvedValue, (h) => {
            u.columnFiltersMeta[C] = h;
          });
        }
      if (l.length) {
        for (let m = 0; m < l.length; m++) {
          p = l[m];
          const C = p.id;
          if (p.filterFn(u, C, p.resolvedValue, (h) => {
            u.columnFiltersMeta[C] = h;
          })) {
            u.columnFilters.__global__ = !0;
            break;
          }
        }
        u.columnFilters.__global__ !== !0 && (u.columnFilters.__global__ = !1);
      }
    }
    const f = (g) => {
      for (let u = 0; u < r.length; u++)
        if (g.columnFilters[r[u]] === !1)
          return !1;
      return !0;
    };
    return Ao(n.rows, f, e);
  }, _(e.options, "debugTable", "getFilteredRowModel", () => e._autoResetPageIndex()));
}
function Ho(e) {
  return (n) => $(() => [n.getState().pagination, n.getPrePaginationRowModel(), n.options.paginateExpandedRows ? void 0 : n.getState().expanded], (t, o) => {
    if (!o.rows.length)
      return o;
    const {
      pageSize: s,
      pageIndex: l
    } = t;
    let {
      rows: r,
      flatRows: i,
      rowsById: a
    } = o;
    const c = s * l, p = c + s;
    r = r.slice(c, p);
    let f;
    n.options.paginateExpandedRows ? f = {
      rows: r,
      flatRows: i,
      rowsById: a
    } : f = Eo({
      rows: r,
      flatRows: i,
      rowsById: a
    }), f.flatRows = [];
    const g = (u) => {
      f.flatRows.push(u), u.subRows.length && u.subRows.forEach(g);
    };
    return f.rows.forEach(g), f;
  }, _(n.options, "debugTable", "getPaginationRowModel"));
}
function No() {
  return (e) => $(() => [e.getState().sorting, e.getPreSortedRowModel()], (n, t) => {
    if (!t.rows.length || !(n != null && n.length))
      return t;
    const o = e.getState().sorting, s = [], l = o.filter((a) => {
      var c;
      return (c = e.getColumn(a.id)) == null ? void 0 : c.getCanSort();
    }), r = {};
    l.forEach((a) => {
      const c = e.getColumn(a.id);
      c && (r[a.id] = {
        sortUndefined: c.columnDef.sortUndefined,
        invertSorting: c.columnDef.invertSorting,
        sortingFn: c.getSortingFn()
      });
    });
    const i = (a) => {
      const c = a.map((p) => ({
        ...p
      }));
      return c.sort((p, f) => {
        for (let u = 0; u < l.length; u += 1) {
          var g;
          const m = l[u], C = r[m.id], h = C.sortUndefined, S = (g = m == null ? void 0 : m.desc) != null ? g : !1;
          let w = 0;
          if (h) {
            const F = p.getValue(m.id), v = f.getValue(m.id), P = F === void 0, x = v === void 0;
            if (P || x) {
              if (h === "first")
                return P ? -1 : 1;
              if (h === "last")
                return P ? 1 : -1;
              w = P && x ? 0 : P ? h : -h;
            }
          }
          if (w === 0 && (w = C.sortingFn(p, f, m.id)), w !== 0)
            return S && (w *= -1), C.invertSorting && (w *= -1), w;
        }
        return p.index - f.index;
      }), c.forEach((p) => {
        var f;
        s.push(p), (f = p.subRows) != null && f.length && (p.subRows = i(p.subRows));
      }), c;
    };
    return {
      rows: i(t.rows),
      flatRows: s,
      rowsById: t.rowsById
    };
  }, _(e.options, "debugTable", "getSortedRowModel", () => e._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function fe(e, n) {
  return e ? Oo(e) ? /* @__PURE__ */ Ee.createElement(e, n) : e : null;
}
function Oo(e) {
  return jo(e) || typeof e == "function" || qo(e);
}
function jo(e) {
  return typeof e == "function" && (() => {
    const n = Object.getPrototypeOf(e);
    return n.prototype && n.prototype.isReactComponent;
  })();
}
function qo(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function Wo(e) {
  const n = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [t] = Ee.useState(() => ({
    current: Do(n)
  })), [o, s] = Ee.useState(() => t.current.initialState);
  return t.current.setOptions((l) => ({
    ...l,
    ...e,
    state: {
      ...o,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (r) => {
      s(r), e.onStateChange == null || e.onStateChange(r);
    }
  })), t.current;
}
const Uo = {
  maxSize: 1e3,
  minSize: 40,
  size: 100
}, Ko = {
  enableColumnActions: !0,
  enablePagination: !0,
  showSkeletons: !0
}, Kl = (e) => {
  const {
    data: n,
    columns: t,
    components: o,
    componentProps: s,
    enableSorting: l = !0,
    enableHiding: r = !0,
    enableColumnPinning: i = !0,
    defaultColumn: a,
    filterFns: c,
    meta: p,
    ...f
  } = e, g = {
    ...Ko,
    ...p
  };
  return { table: Wo({
    data: n,
    columns: t,
    getRowId: (m) => String(m.id),
    filterFns: {
      ...c,
      isWithinDateRange: ds,
      arrIncludesSomeOptions: gs,
      includesSomeOptionValue: ps,
      contains: fs,
      startsWith: ms,
      equals: Cs,
      notEquals: hs
    },
    // Pipeline
    getCoreRowModel: Lo(),
    ...!e.manualFiltering && { getFilteredRowModel: zo() },
    ...!e.manualPagination && (g == null ? void 0 : g.enablePagination) && { getPaginationRowModel: Ho() },
    ...!e.manualSorting && { getSortedRowModel: No() },
    // Defaults
    enableColumnPinning: i,
    enableHiding: r,
    enableSorting: l,
    defaultColumn: {
      ...Uo,
      ...a
    },
    meta: g,
    ...f
  }), components: o, componentProps: s };
}, ut = (e) => {
  const n = H();
  return n.current = e, se(() => n.current, []);
}, Xl = (e, n = 0) => {
  const t = H({}), o = ut(e), s = ut(n);
  return se(
    async (...l) => (t.current.promise || (t.current.promise = new Promise((r, i) => {
      t.current.resolve = r, t.current.reject = i;
    })), t.current.timeout && clearTimeout(t.current.timeout), t.current.timeout = setTimeout(async () => {
      delete t.current.timeout;
      try {
        t.current.resolve(await o()(...l));
      } catch (r) {
        t.current.reject(r);
      } finally {
        delete t.current.promise;
      }
    }, s()), t.current.promise),
    [o, s]
  );
}, Xo = R(() => y({}), {
  name: "gGlobalTable"
}), Jl = (e) => {
  const { instance: n } = V(), { componentProps: t, table: o } = n, { getFlatHeaders: s } = o, { GlobalTableProps: l } = t || {}, {
    classes: r,
    style: i,
    ...a
  } = l || {}, { classes: c, style: p, ...f } = e, g = b(b(Xo(), c), r), u = s(), m = xe(() => {
    const C = {};
    for (let h = 0; h < u.length; h++) {
      const S = u[h];
      let w = S.getSize();
      C[`--header-${Re(S.id)}-size`] = w, C[`--col-${Re(S.column.id)}-size`] = w;
    }
    return C;
  }, [u]);
  return /* @__PURE__ */ d(
    Ot,
    {
      classes: g,
      style: { ...m, ...i, ...p },
      ...f,
      ...a
    }
  );
}, Jo = R(() => y({}), {
  name: "gGlobalTableContainer"
}), Yl = (e) => {
  const { instance: n } = V(), { componentProps: t } = n, { GlobalTableContainerProps: o } = t || {}, { classes: s, ...l } = e, r = b(Jo(), s);
  return /* @__PURE__ */ d(jt, { classes: r, ...o, ...l });
}, Yo = R(() => y({}), {
  name: "gGlobalTableHead"
}), Zl = (e) => {
  const { instance: n } = V(), { table: t, componentProps: o } = n, { GlobalTableHeadProps: s } = o || {}, { children: l, classes: r, ...i } = e, a = b(Yo(), r);
  return /* @__PURE__ */ d(qt, { classes: a, ...s, ...i, children: t.getHeaderGroups().map((c) => l(c)) });
}, Zo = R(
  (e) => y({
    root: {
      backgroundColor: e.palette.common.white
    }
  }),
  {
    name: "gGlobalTableHeadRow"
  }
), Ql = (e) => {
  const { instance: n } = V(), { componentProps: t } = n, { row: o, children: s, classes: l, ...r } = e, { GlobalTableHeadRowProps: i } = t || {}, a = b(Zo(), l);
  return /* @__PURE__ */ d(ye, { classes: a, ...i, ...r, children: o.headers.map((c) => s(c)) });
}, Re = (e) => e.replace(/[^a-zA-Z0-9]/g, "_"), we = (e) => e.value !== void 0 && e.displayValue !== void 0, Qo = (e, n) => e.getRightLeafHeaders().slice(n.getPinnedIndex() + 1).reduce((t, o) => t + o.getSize(), 0), Vt = (e) => {
  switch (e) {
    case "left":
      return "start";
    case "center":
      return "center";
    case "right":
      return "end";
    case "justify":
      return "stretch";
    case "inherit":
      return "inherit";
    default:
      return "start";
  }
}, ot = ({
  column: e,
  header: n,
  table: t,
  theme: o
}) => {
  const s = {
    minWidth: `max(calc(var(--${n ? "header" : "col"}-${Re(
      (n == null ? void 0 : n.id) ?? e.id
    )}-size) * 1px), ${e.columnDef.minSize ?? 30}px)`,
    width: `calc(var(--${n ? "header" : "col"}-${Re(
      (n == null ? void 0 : n.id) ?? e.id
    )}-size) * 1px)`
  };
  return {
    backgroundColor: e.getIsPinned() ? ne(on(o.palette.background.default, 0.01), 0.97) : "inherit",
    left: e.getIsPinned() === "left" ? `${e.getStart("left")}px` : void 0,
    position: e.getIsPinned() ? "sticky" : void 0,
    right: e.getIsPinned() === "right" ? `${Qo(t, e)}px` : void 0,
    transition: "padding 150ms ease-in-out",
    ...s
  };
}, es = R(
  () => y({
    root: ({ isPinned: e }) => ({
      ...e ? { zIndex: 3 } : {},
      "& .GlobalColumnActionButton": {
        opacity: 0
      },
      "&:hover .GlobalColumnActionButton": {
        opacity: 1
      }
    })
  }),
  {
    name: "gGlobalTableHeadCell"
  }
), er = (e) => {
  const { instance: n } = V(), { componentProps: t, table: o } = n, {
    options: { meta: s }
  } = o, { enableColumnActions: l } = s || {}, { header: r, classes: i, style: a, ...c } = e, { GlobalTableHeadCellProps: p } = t || {}, {
    classes: f,
    style: g,
    ...u
  } = p || {}, { meta: m } = r.column.columnDef, { getHeadCellProps: C, enableColumnActions: h = !0 } = m || {}, S = C && C(r.getContext()), { style: w, classes: F, align: v, ...P } = S || {}, x = Ie(), G = b(
    b(es({ isPinned: r.column.getIsPinned() }), i),
    f
  );
  return /* @__PURE__ */ d(
    Fe,
    {
      colSpan: r.colSpan,
      classes: G,
      align: v,
      ...P,
      ...u,
      ...c,
      style: {
        ...ot({ header: r, table: o, column: r.column, theme: x }),
        ...g,
        ...a,
        ...w
      },
      children: r != null && r.isPlaceholder ? null : r.column.getCanSort() ? /* @__PURE__ */ M(T, { display: "flex", alignItems: "center", justifyContent: Vt(v), children: [
        /* @__PURE__ */ d(ns, { header: r }),
        l && h && /* @__PURE__ */ d(ct, { header: r })
      ] }) : /* @__PURE__ */ M(
        T,
        {
          display: "flex",
          alignItems: "center",
          justifyContent: v === "right" ? "end" : "start",
          children: [
            fe(r.column.columnDef.header, r.getContext()),
            l && h && /* @__PURE__ */ d(ct, { header: r })
          ]
        }
      )
    }
  );
}, ts = R(() => y({}), {
  name: "gGlobalTableHeadSortLabel"
}), ns = (e) => {
  const { instance: n } = V(), { componentProps: t } = n, { GlobalTableHeadSortLabelProps: o } = t || {}, { onClick: s, ...l } = o || {}, { header: r, classes: i, ...a } = e, c = b(ts(), i);
  return /* @__PURE__ */ d(
    Wt,
    {
      ...l,
      ...a,
      classes: c,
      onClick: r.column.getToggleSortingHandler(),
      disabled: !r.column.getCanSort(),
      active: !!r.column.getIsSorted(),
      direction: r.column.getIsSorted() === !1 ? void 0 : r.column.getIsSorted(),
      children: fe(r.column.columnDef.header, r.getContext())
    }
  );
}, os = R(() => y({}), {
  name: "gGlobalTableBody"
}), tr = (e) => {
  const { instance: n } = V(), { table: t, componentProps: o } = n, { GlobalTableBodyProps: s } = o || {}, { children: l, classes: r, ...i } = e, a = b(os(), r);
  return /* @__PURE__ */ d(Ut, { classes: a, ...s, ...i, children: t.getRowModel().rows.map((c) => l(c)) });
}, ss = R(
  () => y({
    root: ({ isPinned: e }) => ({
      ...e ? { zIndex: 3 } : {}
    })
  }),
  {
    name: "gGlobalTableBodyCell"
  }
), nr = (e) => {
  const { instance: n } = V(), { componentProps: t, table: o } = n, { options: s } = o, { meta: l } = s, { loading: r, showSkeletons: i } = l || {}, { cell: a, classes: c, style: p, ...f } = e, { GlobalTableBodyCellProps: g } = t || {}, { meta: u } = a.column.columnDef, { getBodyCellProps: m } = u || {}, C = Ie(), h = a.column.getSize(), S = m && m(a.getContext()), { style: w, classes: F, ...v } = S || {}, {
    style: P,
    classes: x,
    ...G
  } = g || {}, I = b(
    b(ss({ isPinned: a.column.getIsPinned() }), c),
    x
  );
  return /* @__PURE__ */ d(
    Fe,
    {
      size: "small",
      classes: I,
      style: {
        ...ot({ table: o, column: a.column, theme: C }),
        ...w,
        ...P,
        ...p
      },
      ...G,
      ...v,
      ...f,
      children: r && i ? /* @__PURE__ */ d(bn, { animation: "wave", height: 20, width: h }) : fe(a.column.columnDef.cell, a.getContext())
    }
  );
}, ls = R(
  (e) => y({
    root: {
      height: "48px",
      "&&:hover": {
        backgroundColor: e.palette.gray[100]
      }
    },
    selected: {
      "&&": {
        backgroundColor: e.palette.blue[100]
      },
      "&&:hover": {
        backgroundColor: e.palette.blue[200]
      }
    }
  }),
  {
    name: "gGlobalTableBodyRow"
  }
), or = (e) => {
  const { instance: n } = V(), {
    componentProps: t,
    table: {
      options: { meta: o, state: s }
    }
  } = n, { rowSelection: l } = s, { renderRowPanel: r } = o || {}, {
    row: i,
    children: a,
    getBodyRowProps: c,
    classes: p,
    style: f,
    ...g
  } = e, { GlobalTableBodyRowProps: u } = t || {}, {
    style: m,
    classes: C,
    ...h
  } = u || {}, S = c && c(i), { style: w, classes: F, ...v } = S || {}, P = b(
    b(b(ls(), C), p),
    F
  ), x = xe(
    () => Object.entries(l || {}).filter(([G, I]) => I).map(([G]) => G),
    [l]
  );
  return /* @__PURE__ */ M(K, { children: [
    /* @__PURE__ */ d(
      ye,
      {
        style: { ...m, ...f, ...w },
        classes: P,
        hover: !0,
        selected: x.includes(i.id),
        ...h,
        ...v,
        ...g,
        children: i.getVisibleCells().map((G) => a(G))
      }
    ),
    r && /* @__PURE__ */ d(is, { row: i })
  ] });
}, rs = R(() => ({
  root: ({ isExpanded: e }) => ({
    transition: "all 150ms ease-in-out 0s",
    padding: e ? "1rem" : "0 1rem",
    ...e ? {} : { border: 0 }
  })
})), is = (e) => {
  const { row: n } = e, { instance: t } = V(), { table: o, componentProps: s } = t, {
    options: { meta: l }
  } = o, { renderRowPanel: r } = l || {}, { GlobalTableBodyRowPanelProps: i } = s || {}, { RowProps: a, CellProps: c, CollapseProps: p } = i || {}, f = rs({ isExpanded: n.getIsExpanded() });
  return /* @__PURE__ */ d(ye, { ...a, children: /* @__PURE__ */ d(
    Fe,
    {
      ...c,
      colSpan: o.getVisibleLeafColumns().length,
      classes: f,
      children: r && /* @__PURE__ */ d(
        Xe,
        {
          ...p,
          in: n.getIsExpanded(),
          "aria-hidden": !n.getIsExpanded(),
          mountOnEnter: !0,
          unmountOnExit: !0,
          children: /* @__PURE__ */ d(K, { children: r({ row: n }) })
        }
      )
    }
  ) });
}, as = R(() => y({}), {
  name: "gGlobalTableFooter"
}), sr = (e) => {
  const { instance: n } = V(), { table: t, componentProps: o } = n, { GlobalTableFooterProps: s } = o || {}, { children: l, classes: r, ...i } = e, a = b(as(), r);
  return /* @__PURE__ */ d(Kt, { classes: a, ...s, ...i, children: t.getFooterGroups().map((c) => l(c)) });
}, us = R(() => y({}), {
  name: "gGlobalTableFooterRow"
}), lr = (e) => {
  const { instance: n } = V(), { componentProps: t } = n, { row: o, children: s, classes: l, ...r } = e, { GlobalTableFooterRowProps: i } = t || {}, a = b(us(), l);
  return /* @__PURE__ */ d(K, { children: /* @__PURE__ */ d(ye, { classes: a, ...i, ...r, children: o.headers.map((c) => s(c)) }) });
}, cs = R(() => y({}), {
  name: "gGlobalTableFooterCell"
}), rr = (e) => {
  const { instance: n } = V(), { componentProps: t, table: o } = n, { header: s, classes: l, style: r, ...i } = e, { GlobalTableFooterCellProps: a } = t || {}, {
    classes: c,
    style: p,
    ...f
  } = a || {}, g = b(b(cs(), l), c), u = Ie();
  return /* @__PURE__ */ d(
    Fe,
    {
      ...f,
      ...i,
      classes: g,
      style: {
        ...ot({ table: o, column: s.column, theme: u }),
        ...p,
        ...r
      },
      children: fe(s.column.columnDef.footer, s.getContext())
    }
  );
}, Tt = Rn(() => Cn({})), V = () => hn(Tt()), ir = ({
  children: e,
  instance: n
}) => {
  const t = Tt();
  return /* @__PURE__ */ d(t.Provider, { value: { instance: n }, children: e });
}, ds = (e, n, t) => {
  const o = oe(e.getValue(n)), s = oe(t[0]), l = oe(t[1]);
  return s && l ? o.getTime() >= s.getTime() && o.getTime() <= l.getTime() : !0;
}, gs = (e, n, t) => t.some((o) => {
  var s;
  return (s = e.getValue(n)) == null ? void 0 : s.includes(o.value);
}), ps = (e, n, t) => e.getValue(n).includes(t.value), fs = (e, n, t) => e.getValue(n).toString().toLowerCase().trim().includes(t.toString().toLowerCase().trim()), ms = (e, n, t) => e.getValue(n).toString().toLowerCase().trim().startsWith(t.toString().toLowerCase().trim()), Cs = (e, n, t) => e.getValue(n).toString().toLowerCase().trim() === (t == null ? void 0 : t.toString().toLowerCase().trim()), hs = (e, n, t) => e.getValue(n).toString().toLowerCase().trim() !== t.toString().toLowerCase().trim(), Ss = R(
  () => y({
    root: {
      "&:empty": {
        minHeight: "auto"
      }
    }
  }),
  {
    name: "gGlobalTableTopToolbar"
  }
), ar = (e) => {
  const { children: n, classes: t, ...o } = e, s = b(Ss(), t), { instance: l } = V(), { componentProps: r = {} } = l, { GlobalTableTopToolbarProps: i } = r;
  return /* @__PURE__ */ d(je, { classes: s, disableGutters: !0, ...i, ...o, children: n });
}, ws = R(
  () => y({
    root: {
      "&:empty": {
        minHeight: "auto"
      }
    }
  }),
  {
    name: "gGlobalTableBottomToolbar"
  }
), ur = (e) => {
  const { children: n, classes: t, ...o } = e, s = b(ws(), t), {
    instance: { componentProps: { GlobalTableBottomToolbarProps: l } = {} }
  } = V();
  return /* @__PURE__ */ d(je, { classes: s, disableGutters: !0, ...l, ...o, children: n });
}, Ps = R(() => y({}), {
  name: "gGlobalTableAlert"
}), cr = (e) => {
  const { children: n, classes: t, ...o } = e, { instance: s } = V(), l = b(Ps(), t), { componentProps: { GlobalTableAlertProps: r } = {} } = s;
  return /* @__PURE__ */ d(Xt, { variant: "filled", severity: "error", classes: l, ...r, ...o, children: n });
}, vs = R(
  () => y({
    root: {
      position: "relative"
    }
  }),
  {
    name: "gGlobalTableLinearProgressBar"
  }
), bs = R(() => ({
  root: ({ isTopBar: e }) => ({
    position: "absolute",
    width: "100%",
    top: e ? void 0 : 0,
    bottom: e ? 0 : void 0
  })
})), dr = (e) => {
  const { instance: n } = V(), {
    componentProps: { GlobalTableLinearProgressBarProps: t } = {},
    table: {
      options: { meta: o }
    }
  } = n, { loading: s } = o || {}, { isTopBar: l, classes: r } = e, i = b(vs(), r), a = bs({ isTopBar: l });
  return /* @__PURE__ */ d(Xe, { in: s, classes: a, mountOnEnter: !0, unmountOnExit: !0, children: /* @__PURE__ */ d(sn, { "aria-busy": "true", "aria-label": "Loading", classes: i, ...t }) });
}, Rs = R(
  (e) => y({
    root: {
      flexWrap: "wrap",
      gridGap: e.spacing(0.5),
      "&:empty": {
        minHeight: "auto"
      }
    }
  }),
  {
    name: "gGlobalTableAppliedFilters"
  }
), ys = ({ column: e }) => {
  const {
    columnDef: { header: n },
    getFilterValue: t,
    id: o
  } = e, s = String(t());
  return /* @__PURE__ */ M(j, { variant: "label", children: [
    typeof n == "string" ? n : o,
    ": ",
    s
  ] });
}, gr = (e) => {
  const { children: n, classes: t, ...o } = e, { instance: s } = V(), { table: l, componentProps: r } = s, { GlobalTableAppliedFiltersProps: i } = r || {}, { BoxProps: a, ChipProps: c, ToolbarProps: p } = i || {}, { onDelete: f, label: g, ...u } = c || {}, { getAllFlatColumns: m } = l, C = b(Rs(), t), h = (S, w) => {
    w.setFilterValue(void 0), f && f(S);
  };
  return /* @__PURE__ */ d(je, { classes: C, disableGutters: !0, ...p, ...o, children: m().map((S) => {
    var w, F;
    return S.getIsFiltered() ? /* @__PURE__ */ d(T, { paddingRight: 1, ...a, children: /* @__PURE__ */ d(
      Ze,
      {
        label: (w = S.columnDef.meta) != null && w.renderFilterChipLabel ? (F = S.columnDef.meta) == null ? void 0 : F.renderFilterChipLabel(S) : /* @__PURE__ */ d(ys, { column: S }),
        onDelete: (v) => h(v, S),
        ...u
      }
    ) }, S.id) : null;
  }) });
}, pr = () => {
  const { instance: e } = V(), { table: n, componentProps: t } = e, { GlobalTableSearchFilterProps: o } = t || {}, { onChange: s, onKeyDown: l, InputProps: r, placeholder: i, ...a } = o || {}, { setGlobalFilter: c, getState: p } = n, { globalFilter: f } = p(), [g, u] = O(f || ""), m = (h) => {
    u(h.target.value), s && s(h);
  }, C = (h) => {
    h.key === "Enter" && c(g), l && l(h);
  };
  return ee(() => {
    u(f || "");
  }, [f]), /* @__PURE__ */ d(
    ue,
    {
      value: g,
      onChange: m,
      onKeyDown: C,
      placeholder: i || "Search",
      autoComplete: "off",
      InputProps: {
        startAdornment: /* @__PURE__ */ d(Pe, { position: "start", children: /* @__PURE__ */ d(ie, { title: "Search", children: /* @__PURE__ */ d(K, { children: /* @__PURE__ */ d(un, { fontSize: "small" }) }) }) }),
        endAdornment: f ? /* @__PURE__ */ d(Pe, { position: "end", children: /* @__PURE__ */ d(N, { onClick: () => c(""), color: "primary", children: /* @__PURE__ */ d(ge, { fontSize: "small" }) }) }) : null,
        ...r
      },
      ...a
    }
  );
}, Fs = R(
  (e) => {
    var n;
    return y({
      icon: {
        color: (n = e.palette.neutral) == null ? void 0 : n.main
      }
    });
  },
  {
    name: "gGlobalTablePaginationSelect"
  }
), fr = () => {
  const { instance: e } = V(), { table: n, componentProps: t } = e, { setPageSize: o } = n, { pageSize: s } = n.getState().pagination, { GlobalTablePaginationSelectProps: l } = t || {}, {
    BoxProps: r,
    TypographyProps: i,
    TextFieldProps: { InputProps: a = {}, SelectProps: c = {}, ...p } = {},
    rowsPerPage: f = [10, 20, 50]
  } = l || {}, g = Fs();
  return /* @__PURE__ */ M(T, { display: "flex", alignItems: "center", ...r, children: [
    /* @__PURE__ */ d(j, { variant: "body2", paddingRight: 2, ...i, children: (i == null ? void 0 : i.children) ?? "Rows per page" }),
    /* @__PURE__ */ d(
      ue,
      {
        select: !0,
        size: "small",
        value: s,
        onChange: (u) => o(Number(u.target.value)),
        InputProps: {
          ...a
        },
        SelectProps: {
          classes: {
            icon: g.icon
          },
          ...c
        },
        ...p,
        children: f.map((u) => /* @__PURE__ */ d(U, { value: u, children: u }, u))
      }
    )
  ] });
}, Is = R(
  (e) => y({
    root: {
      marginBottom: e.spacing(1.5)
    }
  }),
  {
    name: "gGlobalTableTextFilter"
  }
), mr = (e) => {
  const { column: n, ...t } = e, { instance: o } = V(), { componentProps: s } = o, {
    GlobalTableTextFilterProps: {
      classes: l = {},
      style: r = {},
      ...i
    } = {}
  } = s || {}, {
    id: a,
    getFilterValue: c,
    setFilterValue: p,
    columnDef: { header: f }
  } = n, { classes: g, style: u, ...m } = t || {}, C = b(b(Is(), l), g);
  return /* @__PURE__ */ d(
    ue,
    {
      fullWidth: !0,
      size: "small",
      name: a,
      autoComplete: "off",
      classes: C,
      style: { ...r, ...u },
      InputLabelProps: { htmlFor: a },
      onChange: (h) => {
        p(h.target.value || void 0);
      },
      label: typeof f == "string" ? f : a,
      value: c() || "",
      InputProps: {
        inputProps: { "aria-label": typeof f == "string" ? f : a }
      },
      ...i,
      ...m
    }
  );
}, xs = R(
  (e) => y({
    root: {
      marginBottom: e.spacing(1.5)
    }
  }),
  {
    name: "gGlobalTableNumberFilter"
  }
), Cr = (e) => {
  const { column: n, ...t } = e, {
    instance: { componentProps: o }
  } = V(), { GlobalTableNumberFilterProps: s } = o || {}, {
    value: l,
    defaultValue: r,
    type: i,
    style: a,
    classes: c,
    ...p
  } = s || {}, {
    id: f,
    getFilterValue: g,
    setFilterValue: u,
    columnDef: { header: m }
  } = n, { classes: C, style: h, ...S } = t || {}, w = b(b(xs(), C), c);
  return /* @__PURE__ */ d(
    Ae,
    {
      fullWidth: !0,
      size: "small",
      name: f,
      autoComplete: "off",
      style: { ...a, ...h },
      classes: w,
      InputLabelProps: { htmlFor: f },
      onChange: (F) => {
        u(F.target.value || void 0);
      },
      value: g() || "",
      label: typeof m == "string" ? m : f,
      InputProps: {
        inputProps: { "aria-label": m }
      },
      ...p,
      ...S
    }
  );
}, $s = R(
  (e) => y({
    root: {
      marginBottom: e.spacing(1.5)
    }
  }),
  {
    name: "gGlobalTableNumberRangeFilter"
  }
), hr = (e) => {
  var F, v;
  const { column: n, ...t } = e, {
    instance: { componentProps: o }
  } = V(), { GlobalTableNumberFilterProps: s } = o || {}, {
    value: l,
    defaultValue: r,
    type: i,
    style: a,
    classes: c,
    ...p
  } = s || {}, {
    id: f,
    getFilterValue: g,
    setFilterValue: u,
    columnDef: { header: m }
  } = n, { classes: C, style: h, ...S } = t || {}, w = b(b($s(), C), c);
  return /* @__PURE__ */ M(T, { display: "flex", gridGap: 4, children: [
    /* @__PURE__ */ d(
      Ae,
      {
        fullWidth: !0,
        size: "small",
        name: `from${f}`,
        autoComplete: "off",
        style: { ...a, ...h },
        classes: w,
        InputLabelProps: { htmlFor: `from${f}` },
        onChange: (P) => {
          u((x) => [P.target.value, x == null ? void 0 : x[1]]);
        },
        value: ((F = g()) == null ? void 0 : F[0]) ?? "",
        label: typeof m == "string" ? `${m} (min)` : `${f} (min)`,
        InputProps: {
          inputProps: { "aria-label": m }
        },
        ...p,
        ...S
      }
    ),
    /* @__PURE__ */ d(
      Ae,
      {
        fullWidth: !0,
        size: "small",
        name: `to${f}`,
        autoComplete: "off",
        style: { ...a, ...h },
        classes: w,
        InputLabelProps: { htmlFor: `to${f}` },
        onChange: (P) => {
          u((x) => [x == null ? void 0 : x[0], P.target.value]);
        },
        value: ((v = g()) == null ? void 0 : v[1]) ?? "",
        label: typeof m == "string" ? `${m} (max)` : `${f} (max)`,
        InputProps: {
          inputProps: { "aria-label": m }
        },
        ...p,
        ...S
      }
    )
  ] });
}, _s = R(
  (e) => y({
    root: {
      marginBottom: e.spacing(1.5)
    }
  }),
  {
    name: "gGlobalTableSelectFilter"
  }
), Gs = R(() => ({
  select: {
    "&:focus": {
      backgroundColor: "transparent"
    }
  }
})), Vs = R(() => ({
  menuPaper: {
    marginTop: "0.25rem"
  },
  menuItem: {
    height: "38px"
  }
})), Sr = (e) => {
  const { column: n, selectOptions: t = [], showEmptyDefault: o = !1, ...s } = e, {
    id: l,
    setFilterValue: r,
    getFilterValue: i,
    columnDef: { header: a }
  } = n, { instance: c } = V(), { componentProps: p } = c, { GlobalTableSelectFilterProps: f } = p || {}, {
    style: g,
    classes: u,
    ...m
  } = f || {}, { classes: C, style: h, ...S } = s || {}, w = b(b(_s(), u), C), F = Gs(), v = Vs(), [P, x] = O(null), G = H(null);
  return ee(() => {
    G.current && x(G.current);
  }, [G]), /* @__PURE__ */ M(
    ue,
    {
      fullWidth: !0,
      ref: G,
      classes: w,
      style: { ...g, ...h },
      select: !0,
      size: "small",
      value: i() || "",
      label: typeof a == "string" ? a : l,
      SelectProps: {
        classes: {
          select: F.select
        },
        IconComponent: (I) => /* @__PURE__ */ d(Je, { fontSize: "small", ...I }),
        MenuProps: {
          getContentAnchorEl: null,
          anchorEl: P,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
          },
          classes: {
            paper: v.menuPaper
          }
        }
      },
      onChange: (I) => {
        r(I.target.value || void 0);
      },
      ...m,
      ...S,
      children: [
        o && /* @__PURE__ */ d(U, { className: v.menuItem, dense: !0, children: /* @__PURE__ */ d(ve, { disableTypography: !0 }) }),
        t.map((I, A) => /* @__PURE__ */ d(
          U,
          {
            dense: !0,
            value: typeof I == "string" ? I : I.value,
            className: v.menuItem,
            children: /* @__PURE__ */ d(
              ve,
              {
                primary: typeof I == "string" ? I : I.displayValue,
                disableTypography: !0
              }
            )
          },
          A
        ))
      ]
    }
  );
}, Ts = R(
  (e) => y({
    root: {
      marginBottom: e.spacing(1.5),
      width: "100%"
    }
  }),
  {
    name: "gGlobalTableDateFilter"
  }
), wr = (e) => {
  const { column: n, ...t } = e, {
    instance: { componentProps: o }
  } = V(), { GlobalTableDateFilterProps: s } = o || {}, {
    DateFieldProps: {
      classes: l = {},
      style: r = {},
      ...i
    } = {},
    ...a
  } = s || {}, {
    id: c,
    getFilterValue: p,
    setFilterValue: f,
    columnDef: { header: g }
  } = n, u = H(f), m = p(), C = m ? oe(m) : void 0, {
    DateFieldProps: {
      classes: h = {},
      style: S = {},
      ...w
    } = {},
    ...F
  } = t || {}, v = b(b(Ts(), l), h), P = se((x) => {
    u.current(x ? be(x, { representation: "date" }) : void 0);
  }, []);
  return /* @__PURE__ */ d(
    yn,
    {
      label: typeof g == "string" ? g : c,
      value: C,
      viewing: C,
      onDateAccept: P,
      DateFieldProps: {
        InputLabelProps: { htmlFor: c },
        classes: v,
        style: { ...r, ...S },
        ...i,
        ...w
      },
      ...a,
      ...F
    }
  );
}, Ms = R(
  (e) => y({
    root: {
      marginBottom: e.spacing(1.5),
      width: "100%"
    }
  }),
  {
    name: "gGlobalTableDateRangeFilter"
  }
), Pr = (e) => {
  const { column: n, ...t } = e, {
    instance: { componentProps: o }
  } = V(), { GlobalTableDateRangeFilterProps: s } = o || {}, {
    DateRangeFieldProps: {
      classes: l = {},
      style: r = {},
      ...i
    } = {},
    ...a
  } = s || {}, {
    id: c,
    setFilterValue: p,
    getFilterValue: f,
    columnDef: { header: g }
  } = n, u = H(p), m = f(), [C, h] = m && m.length ? [oe(m[0]), oe(m[1])] : [], {
    DateRangeFieldProps: {
      classes: S = {},
      style: w = {},
      ...F
    } = {},
    ...v
  } = t || {}, P = b(b(Ms(), l), S), x = se((G) => {
    u.current(
      G && G[0] && G[1] ? [
        be(G[0], { representation: "date" }),
        be(G[1], { representation: "date" })
      ] : void 0
    );
  }, []);
  return /* @__PURE__ */ d(
    Fn,
    {
      label: typeof g == "string" ? g : c,
      value: C && h ? [C, h] : [],
      viewing: C,
      onDateRangeAccept: x,
      DateRangeFieldProps: {
        classes: P,
        style: { ...r, ...w },
        InputLabelProps: { htmlFor: c },
        ...i,
        ...F
      },
      ...a,
      ...v
    }
  );
}, Ds = R(
  (e) => y({
    root: {
      marginBottom: e.spacing(1.5),
      width: "100%"
    }
  }),
  {
    name: "gGlobalTableDateTimeFilter"
  }
), vr = (e) => {
  const { column: n, ...t } = e, {
    instance: { componentProps: o }
  } = V(), { GlobalTableDateTimeFilterProps: s } = o || {}, {
    DateTimeFieldProps: {
      classes: l = {},
      style: r = {},
      ...i
    } = {},
    ...a
  } = s || {}, {
    id: c,
    getFilterValue: p,
    setFilterValue: f,
    columnDef: { header: g }
  } = n, u = H(f), m = p(), C = m ? oe(m) : void 0, {
    DateTimeFieldProps: {
      classes: h = {},
      style: S = {},
      ...w
    } = {},
    ...F
  } = t || {}, v = b(b(Ds(), l), h), P = se((x) => {
    u.current(x ? be(x, { representation: "complete" }) : void 0);
  }, []);
  return /* @__PURE__ */ d(
    In,
    {
      label: typeof g == "string" ? g : c,
      value: C,
      viewing: C,
      onDateTimeAccept: P,
      DateTimeFieldProps: {
        classes: v,
        style: { ...r, ...S },
        InputLabelProps: { htmlFor: c },
        ...i,
        ...w
      },
      ...a,
      ...F
    }
  );
}, Ls = R(
  () => y({
    root: {
      padding: 0
    }
  }),
  {
    name: "gGlobalTableColumnCheckbox"
  }
), br = (e) => {
  const { instance: n } = V(), { table: t, componentProps: o } = n, { GlobalTableColumnCheckboxProps: s } = o || {}, {
    onChange: l,
    classes: r,
    style: i,
    ...a
  } = s || {}, { row: c, classes: p, style: f, ...g } = e, u = b(Ls(), r), m = c ? {
    checked: c.getIsSelected(),
    disabled: !c.getCanSelect(),
    indeterminate: c.getIsSomeSelected(),
    onChange: c.getToggleSelectedHandler()
  } : {
    checked: t.getIsAllRowsSelected(),
    indeterminate: t.getIsSomeRowsSelected(),
    onChange: t.getToggleAllRowsSelectedHandler()
  };
  return /* @__PURE__ */ d(
    qe,
    {
      size: "medium",
      classes: u,
      style: { ...f, ...i },
      ...a,
      ...g,
      ...m
    }
  );
}, Es = ({
  totalRows: e,
  pageIndex: n,
  pageSize: t
}) => {
  const o = e === 0 ? 0 : n * t + 1, s = e !== -1 ? Math.min(e, (n + 1) * t) : (n + 1) * t, l = e === -1 ? -1 : e;
  return `${o}–${s} of ${l !== -1 ? l : `more than ${s}`}`;
}, As = () => {
  var r;
  const { instance: e } = V(), { table: n } = e, t = n.getPageOptions().length, o = n.getState().pagination.pageSize, s = n.getState().pagination.pageIndex, l = (r = n.options.meta) == null ? void 0 : r.rowCount;
  return /* @__PURE__ */ d(j, { variant: "body2", paddingX: 2, children: typeof l == "number" ? Es({
    totalRows: l,
    pageIndex: s,
    pageSize: o
  }) : `${s + 1} of ${t}` });
}, Rr = () => {
  const { instance: e } = V(), { table: n, componentProps: { GlobalTablePaginationProps: t = {} } = {} } = e, {
    BoxProps: o,
    FirstPageIconButtonProps: s,
    PreviousPageIconButtonProps: l,
    NextPageIconButtonProps: r,
    LastPageIconButtonProps: i,
    showCount: a = !0,
    firstPageIcon: c = /* @__PURE__ */ d(cn, { fontSize: "small" }),
    previousPageIcon: p = /* @__PURE__ */ d(dn, { fontSize: "small" }),
    nextPageIcon: f = /* @__PURE__ */ d(St, { fontSize: "small" }),
    lastPageIcon: g = /* @__PURE__ */ d(gn, { fontSize: "small" })
  } = t, { onClick: u, ...m } = s || {}, { onClick: C, ...h } = l || {}, { onClick: S, ...w } = r || {}, { onClick: F, ...v } = i || {}, {
    options: { meta: P },
    getState: x
  } = n, G = x().pagination, { rowCount: I, loading: A } = P || {}, D = (k) => {
    n.setPageIndex(0), u && u(k);
  }, E = (k) => {
    n.previousPage(), C && C(k);
  }, L = (k) => {
    n.nextPage(), S && S(k);
  }, B = (k) => {
    n.setPageIndex(n.getPageCount() - 1), F && F(k);
  };
  return ee(() => {
    if (A && typeof I != "number")
      return;
    const { pageIndex: k, pageSize: le } = G, me = I ?? n.getPrePaginationRowModel().rows.length;
    k * le > me && n.setPageIndex(Math.floor(me / le));
  }, [G, I, n, A]), /* @__PURE__ */ M(T, { display: "flex", alignItems: "center", ...o, children: [
    a ? /* @__PURE__ */ d(As, {}) : null,
    /* @__PURE__ */ d(
      N,
      {
        onClick: D,
        disabled: !n.getCanPreviousPage(),
        "aria-label": "first page",
        ...m,
        children: c
      }
    ),
    /* @__PURE__ */ d(
      N,
      {
        onClick: E,
        disabled: !n.getCanPreviousPage(),
        "aria-label": "previous page",
        ...h,
        children: p
      }
    ),
    /* @__PURE__ */ d(
      N,
      {
        onClick: L,
        disabled: !n.getCanNextPage(),
        "aria-label": "next page",
        ...w,
        children: f
      }
    ),
    /* @__PURE__ */ d(
      N,
      {
        onClick: B,
        disabled: !n.getCanNextPage(),
        "aria-label": "last page",
        ...v,
        children: g
      }
    )
  ] });
}, ks = R(
  (e) => y({
    root: {
      marginBottom: e.spacing(1.5)
    },
    inputRoot: {
      "&&": {
        height: "auto"
      }
    }
  }),
  {
    name: "gGlobalTableAutocompleteFilter"
  }
), Bs = R(() => ({
  root: {
    marginRight: 8
  }
})), yr = (e) => {
  const { column: n, ...t } = e, { instance: o } = V(), { componentProps: s } = o, { GlobalTableAutocompleteFilterProps: l } = s || {}, {
    id: r,
    getFilterValue: i,
    setFilterValue: a,
    columnDef: { header: c }
  } = n, {
    classes: p,
    style: f,
    ...g
  } = l || {}, {
    selectOptions: u = [],
    multiple: m = !0,
    classes: C,
    style: h,
    ...S
  } = t || {}, w = b(b(ks(), p), C), F = Bs();
  return /* @__PURE__ */ d(
    mt,
    {
      multiple: m,
      options: u,
      classes: w,
      style: { ...h, ...f },
      renderTags: (v, P) => v.map((x, G) => /* @__PURE__ */ Sn(
        Ze,
        {
          ...P({ index: G }),
          key: G,
          label: we(x) ? x.displayValue : x
        }
      )),
      renderInput: (v) => /* @__PURE__ */ d(
        ue,
        {
          ...v,
          fullWidth: !0,
          label: typeof c == "string" ? c : r,
          InputLabelProps: { htmlFor: r },
          InputProps: {
            ...v.InputProps
          }
        }
      ),
      renderOption: (v, { selected: P }) => /* @__PURE__ */ M(K, { children: [
        /* @__PURE__ */ d(qe, { classes: F, checked: P }),
        typeof v == "string" ? v : v.displayValue
      ] }),
      ChipProps: {
        size: "small"
      },
      value: i() ?? [],
      onChange: (v, P) => {
        const x = Array.isArray(P) && !P.length ? void 0 : P;
        a(x ?? void 0);
      },
      getOptionLabel: (v) => we(v) ? v.displayValue : v,
      getOptionSelected: (v, P) => we(v) && we(P) ? v.value === P.value : v === P,
      ...g,
      ...S
    }
  );
}, zs = R(
  (e) => y({
    root: {
      marginBottom: e.spacing(1.5)
    }
  }),
  {
    name: "gGlobalTableCheckboxFilter"
  }
), Fr = (e) => {
  const { column: n, checkboxOptions: t = [], ...o } = e, {
    id: s,
    setFilterValue: l,
    getFilterValue: r,
    columnDef: { header: i }
  } = n, [a, c] = O(r() ?? []), { instance: p } = V(), { componentProps: f } = p, { GlobalTableCheckboxFilterProps: g } = f || {}, {
    style: u,
    classes: m,
    ...C
  } = g || {}, { classes: h, style: S, ...w } = o || {}, F = (P) => {
    const x = P.target.checked ? [...a, P.target.name] : a.filter((G) => G !== P.target.name);
    c(x), l(x.length ? x : void 0);
  }, v = b(b(zs(), m), h);
  return /* @__PURE__ */ d(K, { children: /* @__PURE__ */ d(
    xn,
    {
      classes: v,
      style: { ...u, ...S },
      label: typeof i == "string" ? i : s,
      row: !0,
      ...C,
      ...w,
      children: t.map((P) => /* @__PURE__ */ d(
        Jt,
        {
          checked: r() ? r().includes(
            typeof P == "string" ? P : P.value
          ) : !1,
          onChange: F,
          name: typeof P == "string" ? P : P.value,
          LabelProps: { label: typeof P == "string" ? P : P.displayValue }
        },
        typeof P == "string" ? P : P.value
      ))
    }
  ) });
}, Ir = (e) => {
  const { instance: n } = V(), { componentProps: t } = n, { GlobalTableColumnsToggleButtonProps: o } = t || {}, {
    TooltipProps: s,
    IconButtonProps: l,
    openIcon: r = /* @__PURE__ */ d(ge, {}),
    closeIcon: i = /* @__PURE__ */ d(pn, {})
  } = o || {}, { classes: a, children: c, ref: p, ...f } = e, [g, u] = O(null), { onClick: m, ...C } = l || {}, h = (w) => {
    u(g ? null : w.currentTarget), m && m(w);
  }, S = !!g;
  return /* @__PURE__ */ M(K, { children: [
    /* @__PURE__ */ d(ie, { title: "Show/Hide Columns", ...s, children: /* @__PURE__ */ d(N, { onClick: h, size: "small", ...C, ...f, children: S ? r : i }) }),
    g && /* @__PURE__ */ d(qs, { open: S, onClick: h, anchorEl: g })
  ] });
}, Hs = R(() => y({}), {
  name: "gGlobalTableFilterDrawerToggleButton"
}), xr = (e) => {
  const { instance: n } = V(), { componentProps: t } = n, { GlobalTableToggleFilterButtonProps: o } = t || {}, {
    onClick: s,
    classes: l,
    style: r,
    ...i
  } = o || {}, { children: a, classes: c, ref: p, style: f, ...g } = e, u = b(b(Hs(), c), l), [m, C] = O(!1), h = (w) => {
    C(!0), s && s(w);
  }, S = () => {
    C(!1);
  };
  return /* @__PURE__ */ M(K, { children: [
    /* @__PURE__ */ d(
      Ct,
      {
        startIcon: /* @__PURE__ */ d(fn, {}),
        classes: u,
        variant: "outlined",
        onClick: h,
        style: { ...r, ...f },
        ...i,
        ...g,
        children: a
      }
    ),
    /* @__PURE__ */ d(Js, { open: m, onClose: () => S() })
  ] });
}, Ns = R(() => y({}), {
  name: "gGlobalTableRowToggleButton"
}), $r = (e) => {
  const {
    instance: { componentProps: n }
  } = V(), { GlobalTableRowToggleButtonProps: t } = n || {}, {
    onClick: o,
    expandIcon: s = /* @__PURE__ */ d(Pt, { fontSize: "small" }),
    collapseIcon: l = /* @__PURE__ */ d(Je, { fontSize: "small" }),
    classes: r,
    style: i,
    ...a
  } = t || {}, { row: c, ref: p, classes: f, style: g, ...u } = e, m = (h) => {
    c.toggleExpanded(), o && o(h);
  }, C = b(Ns(), f);
  return /* @__PURE__ */ d(
    N,
    {
      classes: C,
      size: "small",
      onClick: m,
      style: { ...i, ...g },
      ...a,
      ...u,
      children: c.getIsExpanded() ? s : l
    }
  );
}, Os = R(() => y({}), {
  name: "gGlobalTableColumnActionsButton"
}), ct = (e) => {
  const {
    instance: { componentProps: n }
  } = V(), { GlobalTableColumnActionsButtonProps: t } = n || {}, {
    TooltipProps: o,
    IconButtonProps: s,
    icon: l = /* @__PURE__ */ d(wt, { fontSize: "small" })
  } = t || {}, { header: r } = e, [i, a] = O(null), { onClick: c, ...p } = s || {}, f = Os();
  return /* @__PURE__ */ M(K, { children: [
    /* @__PURE__ */ d(
      ie,
      {
        enterDelay: 1e3,
        enterNextDelay: 1e3,
        placement: "top",
        title: "Column Actions",
        ...o,
        children: /* @__PURE__ */ d(
          N,
          {
            onClick: (u) => {
              u.stopPropagation(), u.preventDefault(), a(u.currentTarget), c && c(u);
            },
            size: "small",
            title: void 0,
            ...p,
            className: "GlobalColumnActionButton",
            classes: f,
            children: l
          }
        )
      }
    ),
    i && /* @__PURE__ */ d(
      Ks,
      {
        anchorEl: i,
        header: r,
        setAnchorEl: a
      }
    )
  ] });
}, js = R(() => ({
  popper: {
    zIndex: 100
  }
})), qs = (e) => {
  const { open: n, anchorEl: t, onClick: o } = e, { instance: s } = V(), { table: l, componentProps: r } = s, {
    getAllColumns: i,
    initialState: { columnVisibility: a },
    options: { meta: c }
  } = l, p = i(), { GlobalTableColumnsToggleMenuProps: f } = r || {}, { PaperProps: g, PopperProps: u } = f || {}, {
    className: m,
    open: C,
    anchorEl: h,
    ...S
  } = u || {}, { renderColumnsToggleMenuItems: w } = c || {}, F = js(), v = (I) => {
    o(I);
  }, P = Object.entries(a).filter(([I, A]) => !A).map(([I]) => I), x = p.filter((I) => !I.getCanHide()).map((I) => I.id), G = p.filter((I) => !P.includes(I.id)).filter((I) => !x.includes(I.id)).map((I) => /* @__PURE__ */ d(We, { role: void 0, dense: !0, children: /* @__PURE__ */ d(Ue, { children: /* @__PURE__ */ d(
    Yt,
    {
      control: /* @__PURE__ */ d(
        qe,
        {
          edge: "start",
          size: "small",
          color: "primary",
          checked: I.getIsVisible(),
          onChange: I.getToggleVisibilityHandler(),
          disabled: !I.getCanHide(),
          tabIndex: -1,
          disableRipple: !0,
          inputProps: {
            "aria-labelledby": I.id
          }
        }
      ),
      id: I.id,
      label: typeof I.columnDef.header == "string" ? I.columnDef.header : I.id
    }
  ) }) }, I.id));
  return /* @__PURE__ */ d(
    ln,
    {
      className: q(F.popper, m),
      open: n,
      anchorEl: t,
      modifiers: {
        flip: {
          enabled: !1
        }
      },
      ...S,
      children: /* @__PURE__ */ d(ft, { ...g, children: /* @__PURE__ */ d(rn, { onClickAway: v, children: /* @__PURE__ */ d(Ke, { children: (w == null ? void 0 : w({ internalMenuItems: G })) ?? G }) }) })
    }
  );
}, Ws = R(() => ({
  root: {
    justifyContent: "space-between",
    alignItems: "center"
  }
})), Us = R(() => ({
  root: {
    display: "flex",
    alignItems: "center"
  }
})), Ks = (e) => {
  const { instance: n } = V(), { table: t, componentProps: o } = n, { GlobalTableColumnActionMenuProps: s } = o || {}, { onClose: l, ...r } = s || {}, {
    resetColumnVisibility: i,
    getState: a,
    options: { enableSorting: c, enableSortingRemoval: p, enableHiding: f, enableColumnPinning: g, meta: u }
  } = t, { renderColumnActionMenuItems: m } = u || {}, { header: C, setAnchorEl: h, anchorEl: S } = e, { column: w } = C, { columnVisibility: F } = a(), v = Ws(), P = Us(), x = () => {
    w.clearSorting(), h(null);
  }, G = () => {
    w.toggleSorting(!1), h(null);
  }, I = () => {
    w.toggleSorting(!0), h(null);
  }, A = () => {
    w.toggleVisibility(!1), h(null);
  }, D = (k) => {
    w.pin(k), h(null);
  }, E = () => {
    i(), h(null);
  }, L = (k, le) => {
    h(null), l && l(k, le);
  }, B = [
    ...c && w.getCanSort() ? [
      /* @__PURE__ */ d(
        U,
        {
          classes: v,
          disabled: w.getIsSorted() === "asc",
          onClick: G,
          children: /* @__PURE__ */ d(T, { classes: P, children: "Sort by ASC" })
        },
        0
      ),
      /* @__PURE__ */ d(
        U,
        {
          classes: v,
          disabled: w.getIsSorted() === "desc",
          onClick: I,
          children: /* @__PURE__ */ d(T, { classes: P, children: "Sort by DES" })
        },
        1
      ),
      p !== !1 && /* @__PURE__ */ d(
        U,
        {
          classes: v,
          disabled: !w.getIsSorted(),
          divider: g || f,
          onClick: x,
          children: /* @__PURE__ */ d(T, { classes: P, children: "Clear sort" })
        },
        2
      )
    ] : [],
    ...g && w.getCanPin() ? [
      /* @__PURE__ */ d(
        U,
        {
          disabled: w.getIsPinned() === "left" || !w.getCanPin(),
          onClick: () => D("left"),
          classes: v,
          children: /* @__PURE__ */ d(T, { classes: P, children: "Pin to left" })
        },
        3
      ),
      /* @__PURE__ */ d(
        U,
        {
          disabled: w.getIsPinned() === "right" || !w.getCanPin(),
          onClick: () => D("right"),
          classes: v,
          children: /* @__PURE__ */ d(T, { classes: P, children: "Pin to right" })
        },
        4
      ),
      /* @__PURE__ */ d(
        U,
        {
          disabled: !w.getIsPinned(),
          divider: f,
          onClick: () => D(!1),
          classes: v,
          children: /* @__PURE__ */ d(T, { classes: P, children: "Unpin" })
        },
        5
      )
    ] : [],
    ...f ? [
      /* @__PURE__ */ d(
        U,
        {
          disabled: !w.getCanHide(),
          onClick: A,
          classes: v,
          children: /* @__PURE__ */ d(T, { classes: P, children: "Hide column" })
        },
        6
      ),
      /* @__PURE__ */ d(
        U,
        {
          disabled: !Object.values(F).filter((k) => !k).length,
          onClick: E,
          classes: v,
          children: /* @__PURE__ */ d(T, { classes: P, children: "Show all columns" })
        },
        7
      )
    ] : []
  ].filter(Boolean);
  return /* @__PURE__ */ d(pt, { anchorEl: S, open: !!S, onClose: L, ...r, children: (m == null ? void 0 : m({ internalMenuItems: B })) ?? B });
}, Xs = R(
  (e) => y({
    drawer: {
      overflow: "visible"
    },
    box: {
      padding: e.spacing(3),
      width: "400px",
      height: "100%",
      display: "flex",
      flexDirection: "column"
    },
    title: {
      paddingBottom: e.spacing(3)
    },
    buttonBox: {
      marginTop: "auto"
    }
  }),
  { name: "gGlobalTableFilterDrawer" }
), Js = ({ open: e, onClose: n }) => {
  const { instance: t } = V(), { table: o, componentProps: s } = t, {
    options: { meta: l }
  } = o, { renderFilterDrawerItems: r } = l || {}, { GlobalTableFilterDrawerProps: i } = s || {}, { anchor: a, title: c, ...p } = i || {}, f = Xs(), g = o.getHeaderGroups(), u = () => {
    n();
  }, m = () => {
    o.resetColumnFilters(), u();
  }, C = xe(() => g.flatMap(
    (h) => h.headers.map((S) => {
      var w;
      return S.column.getCanFilter() ? /* @__PURE__ */ d(pe, { children: fe((w = S.column.columnDef.meta) == null ? void 0 : w.filter, S.getContext()) }, S.column.id) : null;
    })
  ), [g]);
  return /* @__PURE__ */ d(
    ht,
    {
      anchor: a ?? "right",
      open: e,
      onClose: u,
      PaperProps: {
        className: f.drawer
      },
      ...p,
      children: /* @__PURE__ */ M(T, { className: f.box, children: [
        /* @__PURE__ */ M(T, { display: "flex", flexDirection: "row", justifyContent: "space-between", paddingBottom: 3, children: [
          /* @__PURE__ */ d(j, { variant: "h3", fontWeight: "bold", children: c ?? "Filters" }),
          /* @__PURE__ */ d(N, { onClick: u, size: "small", children: /* @__PURE__ */ d(ge, {}) })
        ] }),
        (r == null ? void 0 : r({ internalDrawerItems: C })) ?? C,
        /* @__PURE__ */ d(T, { className: f.buttonBox, children: /* @__PURE__ */ d(Ct, { variant: "outlined", onClick: m, fullWidth: !0, children: "Clear All Filters" }) })
      ] })
    }
  );
}, Ys = R(() => y({}), {
  name: "gGlobalTableLinkCell"
}), _r = (e) => {
  const {
    instance: { componentProps: n }
  } = V(), { GlobalTableLinkCellProps: t } = n || {}, { children: o, classes: s, ref: l, ...r } = e, i = b(Ys(), s);
  return /* @__PURE__ */ d(Zt, { classes: i, variant: "body2", underline: "always", ...t, ...r, children: o });
}, Gr = (e) => {
  const {
    row: n,
    column: t,
    value: o,
    editComponent: s,
    onCellUpdate: l,
    children: r,
    isEditable: i = !0,
    isProcessing: a,
    processingComponent: c
  } = e, {
    id: p,
    columnDef: { meta: f }
  } = t, { getBodyCellProps: g } = f || {}, [u, m] = O(!1), [C, h] = O(o), S = n.getVisibleCells().find((I) => I.column.id === p), w = S && g && g(S.getContext()), { align: F } = w || {}, v = () => {
    m(!0);
  }, P = (I) => {
    h(I.target.value);
  }, x = se(() => {
    h(o), m(!1);
  }, [o]), G = () => {
    const I = { ...n, original: { ...n.original, [p]: C } };
    m(!1), l(I);
  };
  return ee(() => {
    x();
  }, [x]), u ? /* @__PURE__ */ M(T, { display: "flex", flexDirection: "row", children: [
    s(C, P),
    /* @__PURE__ */ d(ie, { title: "Save", children: /* @__PURE__ */ d(
      N,
      {
        onClick: G,
        disabled: C === o,
        size: "small",
        "data-tc": "tableCellEditConfirm",
        color: "default",
        children: /* @__PURE__ */ d(vt, {})
      }
    ) }),
    /* @__PURE__ */ d(ie, { title: "Cancel", children: /* @__PURE__ */ d(
      N,
      {
        onClick: x,
        size: "small",
        "data-tc": "tableCellEditCancel",
        color: "default",
        children: /* @__PURE__ */ d(ge, {})
      }
    ) })
  ] }) : /* @__PURE__ */ M(T, { display: "flex", alignItems: "center", justifyContent: Vt(F), children: [
    r,
    a && c ? c : null,
    i && !a ? /* @__PURE__ */ d(ie, { title: "Edit", children: /* @__PURE__ */ d(N, { onClick: v, size: "small", "data-tc": "tableCellEdit", color: "default", children: /* @__PURE__ */ d(mn, {}) }) }) : null
  ] });
}, Zs = R(
  () => y({
    root: {},
    card: ({ width: e }) => ({
      width: `${e}px`,
      maxWidth: 1024,
      overflow: "hidden"
    }),
    media: ({ height: e }) => ({
      height: `${e}px`,
      maxHeight: 500
    })
  }),
  { name: "gNavigationCard" }
), Qs = (e) => {
  const {
    media: { image: n, title: t },
    title: o,
    subTitle: s,
    width: l = 500,
    height: r = 120,
    onClick: i,
    classes: a = {},
    CardProps: c,
    CardActionAreaProps: p,
    CardMediaProps: f,
    CardContentProps: g
  } = e, u = Zs({ width: l, height: r });
  return /* @__PURE__ */ d(gt, { ...c, className: q(u.card, a == null ? void 0 : a.card), children: /* @__PURE__ */ M(Qt, { ...p, onClick: i, children: [
    /* @__PURE__ */ d(
      en,
      {
        ...f,
        className: q(u.media, a == null ? void 0 : a.media),
        image: n,
        title: t
      }
    ),
    /* @__PURE__ */ M(tn, { ...g, children: [
      /* @__PURE__ */ d(j, { variant: "body1", fontWeight: "fontWeightBold", children: o }),
      s ? /* @__PURE__ */ d(j, { variant: "body2", color: "textSecondary", children: s }) : null
    ] })
  ] }) });
};
Qs.displayName = "NavigationCard";
const el = R((e) => ({
  drawer: ({ isFirstLevelNavigation: n }) => ({
    backgroundColor: n ? e.palette.blue[1500] : e.palette.primary.dark
  }),
  drawerOpen: ({ width: n }) => ({
    width: n,
    transition: e.transitions.create("width", {
      easing: e.transitions.easing.sharp,
      duration: e.transitions.duration.enteringScreen
    })
  }),
  drawerClose: ({ minWidth: n }) => ({
    width: n,
    transition: e.transitions.create("width", {
      easing: e.transitions.easing.sharp,
      duration: e.transitions.duration.leavingScreen
    }),
    overflowX: "hidden"
  }),
  paper: ({ isFirstLevelNavigation: n }) => ({
    color: e.palette.common.white,
    backgroundColor: n ? e.palette.blue[1500] : e.palette.primary.dark,
    borderRight: "none",
    overflow: "visible"
  }),
  grabArea: ({ width: n }) => ({
    width: "40px",
    height: "100%",
    position: "absolute",
    left: n,
    opacity: 0
  })
})), tl = Ye((e, n) => {
  const {
    width: t,
    minWidth: o = 0,
    children: s,
    open: l,
    classes: r = {},
    enableGrabArea: i = !1,
    isFirstLevelNavigation: a = !1,
    ...c
  } = e, p = b(
    el({ width: t, minWidth: o, isFirstLevelNavigation: a }),
    r
  );
  return /* @__PURE__ */ M(
    ht,
    {
      ref: n,
      role: "navigation",
      variant: "permanent",
      anchor: "left",
      classes: {
        root: q(p.drawer, {
          [p.drawerOpen]: l,
          [p.drawerClose]: !l
        }),
        paper: q(p.paper, {
          [p.drawerOpen]: l,
          [p.drawerClose]: !l
        })
      },
      ...c,
      children: [
        s,
        i && /* @__PURE__ */ d(T, { className: p.grabArea, "data-testid": "grab-area" })
      ]
    }
  );
});
tl.displayName = "GlobalSideNavBar";
const nl = R(
  () => y({
    root: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        display: "none"
      }
    }
  }),
  {
    name: "gGlobalSideNavBarBody"
  }
), Vr = (e) => {
  const { children: n, classes: t, ...o } = e, s = b(nl(), t);
  return /* @__PURE__ */ d(T, { className: s.root, ...o, children: n });
}, ol = R(
  () => y({
    root: {
      display: "flex",
      cursor: "pointer"
    }
  }),
  {
    name: "gGlobalSideNavBarBodyMinimized"
  }
), Tr = (e) => {
  const { children: n, classes: t, ...o } = e, s = b(ol(), t);
  return /* @__PURE__ */ d(T, { className: s.root, ...o, children: n });
}, sl = R(
  () => y({
    root: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      flexShrink: 0
    },
    hidden: {
      visibility: "hidden"
    }
  }),
  {
    name: "gGlobalSideNavBarHeader"
  }
), Mr = (e) => {
  const { children: n, classes: t, isHidden: o, ...s } = e, l = b(sl(), t);
  return /* @__PURE__ */ d(
    T,
    {
      className: q(l.root, {
        [l.hidden]: o
      }),
      ...s,
      children: n
    }
  );
}, ll = (e, n) => {
  n((t) => ({
    ...t,
    [e]: !t[e]
  }));
}, rl = (e) => e.reduce(
  (n, { items: t }) => (t.forEach((o) => {
    var s;
    typeof o.defaultExpanded == "boolean" ? n[o.id] = o.defaultExpanded : (s = o.childItems) != null && s.length && (n[o.id] = !0);
  }), n),
  {}
), il = R(
  (e) => y({
    icon: {
      minWidth: "24px",
      stroke: e.palette.blue[200],
      color: e.palette.blue[200],
      "& svg": {
        width: "24px",
        height: "24px"
      }
    },
    iconSelected: {
      stroke: e.palette.primary.accent,
      color: e.palette.primary.accent
    },
    title: {
      color: e.palette.blue[200],
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    titleSelected: {
      color: e.palette.common.white,
      fontWeight: 600
    }
  }),
  {
    name: "gGlobalSideNavBarItemContent"
  }
), al = (e) => {
  const {
    listItem: { icon: n, title: t },
    isSelected: o,
    classes: s = {}
  } = e, l = b(il(), s);
  return /* @__PURE__ */ M(K, { children: [
    n && /* @__PURE__ */ d(
      Ue,
      {
        className: q([
          l.icon,
          {
            [l.iconSelected]: o
          }
        ]),
        children: n
      }
    ),
    /* @__PURE__ */ d(ve, { children: /* @__PURE__ */ d(
      j,
      {
        variant: "body2",
        className: q([
          l.title,
          {
            [l.titleSelected]: o
          }
        ]),
        children: t
      }
    ) })
  ] });
}, ae = (e) => y({
  divider: {
    backgroundColor: e.palette.common.white,
    opacity: "20%",
    margin: e.spacing(0, 1, 1)
  },
  topLink: {
    "& *": {
      color: e.palette.blue[100]
    },
    "& > li": {
      "&:hover": {
        backgroundColor: e.palette.blue[1500]
      }
    },
    backgroundColor: e.palette.blue[1500]
  },
  listItem: {
    padding: e.spacing(1),
    transition: "all 0.2s ease-in",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    height: "40px"
  }
});
R((e) => ({
  ...ae(e)
}));
const dt = (e) => ({
  "&&": {
    backgroundColor: ne(e.palette.common.white, 0.1),
    borderLeft: `4px solid ${e.palette.primary.accent}`,
    "&:hover": {
      backgroundColor: ne(e.palette.common.white, 0.1)
    }
  }
}), ul = R(
  (e) => y({
    listItem: ({ link: n }) => ({
      ...ae(e).listItem,
      gap: e.spacing(1),
      cursor: n ? "pointer" : "auto",
      "& p": {
        fontWeight: 600
      },
      "&:hover": n ? {
        backgroundColor: ne(e.palette.common.white, 0.075)
      } : {}
    }),
    nested: ({ link: n }) => ({
      padding: e.spacing(0.5, 1, 0.5, 2),
      transition: "all 0.2s ease-in",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: e.spacing(1),
      height: "40px",
      cursor: n ? "pointer" : "auto",
      "&:hover": {
        backgroundColor: ne(e.palette.common.white, 0.075)
      }
    }),
    listItemSelected: () => ({
      paddingLeft: e.spacing(0.5),
      ...dt(e)
    }),
    nestedSelected: () => ({
      paddingLeft: e.spacing(1.5),
      ...dt(e)
    }),
    toggleButton: {
      color: e.palette.blue[200],
      "&:hover": {
        backgroundColor: ne(e.palette.common.white, 0.075)
      }
    }
  }),
  {
    name: "gGlobalSideNavBarItem"
  }
), Mt = (e) => {
  const {
    listItem: n,
    isChildItem: t = !1,
    itemsExpandedState: o,
    classes: s = {},
    ItemContentProps: l = {},
    getIsSelected: r,
    setItemsExpandedState: i,
    onClick: a
  } = e, { id: c, title: p, link: f, childItems: g, disableCollapse: u = !1 } = n, m = b(ul({ link: f }), s), C = (w) => {
    w.stopPropagation(), ll(c, i);
  }, h = (w) => {
    a && a(w, n);
  }, S = r && r(f || "");
  return /* @__PURE__ */ M(
    We,
    {
      "aria-label": p,
      selected: S,
      classes: {
        root: t ? m.nested : m.listItem,
        selected: t ? m.nestedSelected : m.listItemSelected
      },
      onClick: h,
      children: [
        /* @__PURE__ */ d(
          al,
          {
            listItem: n,
            isSelected: S,
            ...l
          }
        ),
        !!(g != null && g.length) && !u && /* @__PURE__ */ d(
          N,
          {
            size: "small",
            onClick: C,
            "aria-label": "Toggle Button",
            className: m.toggleButton,
            darkMode: !0,
            children: o[c] ? /* @__PURE__ */ d(Pt, { fontSize: "small", titleAccess: "Collapse Icon" }) : /* @__PURE__ */ d(Je, { fontSize: "small", titleAccess: "Expand Icon" })
          }
        )
      ]
    }
  );
}, cl = R(
  (e) => y({
    listItem: {
      ...ae(e).listItem,
      justifyContent: "center"
    },
    listItemSelected: {
      "&&": {
        backgroundColor: "unset"
      },
      borderLeft: `2px solid ${e.palette.primary.accent}`
    },
    icon: {
      minWidth: "24px",
      stroke: e.palette.blue[200],
      color: e.palette.blue[200],
      padding: e.spacing(0.1),
      "& svg": {
        width: "24px",
        height: "24px"
      }
    },
    iconSelected: {
      stroke: e.palette.primary.accent,
      color: e.palette.primary.accent
    },
    iconSubstitute: {
      backgroundColor: e.palette.common.white,
      width: "4px",
      height: "4px",
      borderRadius: "50%",
      margin: "auto",
      opacity: "30%"
    },
    iconSubstituteSelected: {
      backgroundColor: e.palette.common.white,
      opacity: "100%"
    }
  }),
  {
    name: "gGlobalSideNavBarItemMinimized"
  }
), Dt = (e) => {
  const { listItem: n, getIsSelected: t, classes: o = {} } = e, { icon: s, title: l, link: r } = n, i = t && t(r || ""), a = b(cl(), o);
  return /* @__PURE__ */ d(
    We,
    {
      "aria-label": l,
      selected: i,
      classes: {
        root: a.listItem,
        selected: a.listItemSelected
      },
      children: s ? /* @__PURE__ */ d(
        Ue,
        {
          className: q([
            a.icon,
            {
              [a.iconSelected]: i
            }
          ]),
          children: s
        }
      ) : /* @__PURE__ */ d(
        "div",
        {
          className: q([
            a.iconSubstitute,
            {
              [a.iconSubstituteSelected]: i
            }
          ]),
          "data-testid": "minimized-item-icon-substitute"
        }
      )
    }
  );
}, dl = R(
  (e) => y({
    ...ae(e),
    label: {
      padding: e.spacing(1.5, 1, 0.5, 1),
      color: ne(e.palette.blue[200], 0.6)
    }
  }),
  {
    name: "gGlobalSideNavBarItemsList"
  }
), Lt = (e, n, t) => e.map((o) => {
  const { itemsExpandedState: s } = n;
  return /* @__PURE__ */ M(pe, { children: [
    /* @__PURE__ */ d(Mt, { listItem: o, ...n }),
    o.childItems && /* @__PURE__ */ d(nn, { in: s[o.id], unmountOnExit: !0, timeout: t, children: /* @__PURE__ */ d(Ke, { disablePadding: !0, children: Lt(
      o.childItems,
      { ...n, isChildItem: !0 },
      t
    ) }) })
  ] }, o.id);
}), Dr = (e) => {
  const {
    topListItem: n,
    onTopListItemClick: t,
    sideNavBarItems: o,
    classes: s = {},
    transitionDuration: l = "auto",
    ItemProps: r = {},
    ItemContentProps: i = {}
  } = e, a = b(dl(), s), [c, p] = O({});
  return ee(() => {
    const f = rl(o);
    p(f);
  }, [o]), /* @__PURE__ */ M(K, { children: [
    n && /* @__PURE__ */ d("div", { className: a.topLink, children: /* @__PURE__ */ d(
      Mt,
      {
        listItem: n,
        itemsExpandedState: c,
        setItemsExpandedState: p,
        ...r,
        ItemContentProps: { ...i },
        onClick: t
      }
    ) }),
    o.map(({ label: f, items: g }, u) => /* @__PURE__ */ M(pe, { children: [
      f && /* @__PURE__ */ d(j, { variant: "label", fontWeight: "600", className: a.label, children: f }),
      /* @__PURE__ */ d(Oe, { className: a.divider }),
      Lt(
        g,
        {
          itemsExpandedState: c,
          setItemsExpandedState: p,
          ItemContentProps: i,
          ...r
        },
        l
      )
    ] }, `listItems-${u}`))
  ] });
}, gl = R(
  (e) => y({
    ...ae(e),
    topLink: {
      ...ae(e).topLink
    },
    minimizedList: ({ width: n }) => ({
      width: n
    }),
    hiddenLabel: {
      padding: e.spacing(1.5, 1, 0.5, 1),
      visibility: "hidden",
      whiteSpace: "nowrap"
    }
  }),
  {
    name: "gGlobalSideNavBarItemsListMinimized"
  }
), Et = (e, n) => e.map((t) => /* @__PURE__ */ M(pe, { children: [
  /* @__PURE__ */ d(Dt, { ...n, listItem: t }),
  t.childItems && Et(t.childItems, n)
] }, t.id)), Lr = (e) => {
  const { sideNavBarItems: n, topListItem: t, classes: o = {}, ItemProps: s, width: l = 40 } = e, r = b(gl({ width: l }), o);
  return /* @__PURE__ */ M(Ke, { disablePadding: !0, className: r.minimizedList, children: [
    t && /* @__PURE__ */ d("div", { className: r.topLink, children: /* @__PURE__ */ d(Dt, { listItem: t, ...s }) }),
    n.map(({ label: i, items: a }, c) => /* @__PURE__ */ M(pe, { children: [
      i && /* @__PURE__ */ d(j, { variant: "label", className: r.hiddenLabel, children: i }),
      /* @__PURE__ */ d(Oe, { className: r.divider }),
      Et(a, s)
    ] }, `minimized-listItems-${c}`))
  ] });
}, pl = R(
  (e) => y({
    root: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: e.spacing(1),
      gap: e.spacing(1)
    }
  }),
  {
    name: "gGlobalMenuItem"
  }
), Er = ({ children: e, classes: n, ...t }) => {
  const o = b(pl(), n);
  return /* @__PURE__ */ d(U, { classes: o, ...t, children: e });
}, fl = R(
  (e) => y({
    root: {
      height: "100%",
      display: "flex",
      alignItems: "center",
      gap: e.spacing(1)
    }
  }),
  {
    name: "gGlobalMenuItemLeading"
  }
), Ar = (e) => {
  const { children: n, ref: t, classes: o, ...s } = e, l = b(fl(), o);
  return /* @__PURE__ */ d(T, { className: l.root, ...s, children: n });
}, ml = R(
  (e) => y({
    root: {
      height: "100%",
      display: "flex",
      alignItems: "center",
      gap: e.spacing(1)
    }
  }),
  {
    name: "gGlobalMenuItemTrailing"
  }
), kr = (e) => {
  const { children: n, ref: t, classes: o, ...s } = e, l = b(ml(), o);
  return /* @__PURE__ */ d(T, { className: l.root, ...s, children: n });
}, Cl = R(
  () => y({
    root: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flex: 1
    },
    listText: {
      margin: 0
    }
  }),
  {
    name: "gGlobalMenuItemContent"
  }
), Br = (e) => {
  const { children: n, ref: t, classes: o, ...s } = e, l = b(Cl(), o);
  return /* @__PURE__ */ d(T, { className: l.root, ...s, children: /* @__PURE__ */ d(
    ve,
    {
      classes: {
        root: l.listText
      },
      children: n
    }
  ) });
}, hl = R(
  () => y({
    root: {
      display: "flex",
      alignItems: "end"
    }
  }),
  { name: "gInputGroup" }
), zr = (e) => {
  const { as: n = "div", children: t, classes: o, className: s, ...l } = e, r = b(hl(), o);
  return /* @__PURE__ */ d(n, { className: q(r.root, s), ...l, children: t });
}, Sl = R(
  (e) => y({
    root: {
      "&:has($first) + &:has($last) fieldset": {
        borderLeft: `1px solid ${e.palette.gray[300]}`
      }
    },
    middle: {
      "& fieldset": {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      }
    },
    first: {
      "& fieldset": {
        borderRight: 0,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      }
    },
    last: {
      "& fieldset": {
        borderLeft: 0,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      }
    }
  }),
  { name: "gInputGroupItem" }
), Hr = (e) => {
  const {
    as: n = "div",
    disabled: t,
    error: o,
    children: s,
    position: l,
    className: r,
    classes: i,
    ...a
  } = e, c = b(Sl(), i), p = se(() => wn.map(s, (f) => Pn(f) ? vn(f, {
    disabled: t,
    error: o,
    helperText: void 0,
    className: q(
      l ? "" : c.middle,
      l === "last" ? c.last : "",
      l === "first" ? c.first : ""
    )
  }) : f), [s, c.first, c.last, c.middle, t, o, l]);
  return /* @__PURE__ */ d(n, { className: q(c.root, r), ...a, children: p() });
};
function wl(e) {
  var n = e.theme, t = e.name, o = e.props;
  if (!n || !n.props || !n.props[t])
    return o;
  var s = n.props[t], l;
  for (l in s)
    o[l] === void 0 && (o[l] = s[l]);
  return o;
}
const re = (e, n, t) => {
  var l, r, i, a, c;
  const { color: o } = n, s = t ? 300 : 1200;
  switch (o) {
    case "primary":
      return (l = e.palette.blue) == null ? void 0 : l[s];
    case "success":
      return (r = e.palette.green) == null ? void 0 : r[t ? 300 : 700];
    case "warning":
      return (i = e.palette.orange) == null ? void 0 : i[s];
    case "error":
      return (a = e.palette.red) == null ? void 0 : a[t ? 300 : 700];
    default:
      return (c = e.palette.gray) == null ? void 0 : c[t ? 300 : 900];
  }
}, Pl = R(
  (e) => y({
    root: (n) => ({
      "&:hover": {
        backgroundColor: n.isSelected ? re(e, n) : re(e, n, !0)
      }
    }),
    label: () => ({
      "&:not(:last-child)": {
        marginRight: 0
      }
    }),
    clickable: (n) => ({
      backgroundColor: n.isSelected ? re(e, n) : lt(e, n),
      color: n.isSelected ? e.palette.common.white : $n(e, n),
      "&:hover:focus": {
        backgroundColor: n.isSelected ? re(e, n) : re(e, n, !0)
      },
      "&:focus": {
        backgroundColor: n.isSelected ? re(e, n) : lt(e, n)
      }
    })
  }),
  { name: "gGlobalSelectableChip" }
), vl = (e) => /* @__PURE__ */ d(_n, { ...e, children: /* @__PURE__ */ d(vt, { titleAccess: "Selected Icon" }) }), bl = Ye((e, n) => {
  const t = Ie(), o = wl({ name: "gGlobalSelectableChip", props: { ...e }, theme: t }), {
    classes: s = {},
    size: l,
    color: r = "primary",
    disabled: i,
    Icon: a,
    onClick: c,
    ...p
  } = o, [f, g] = O(!1), u = (S) => {
    g(!f), c == null || c(S);
  }, m = f ? vl : a || void 0, C = Pl({ size: l, color: r, disabled: i, isSelected: f }), h = b(C, s);
  return /* @__PURE__ */ d(
    Ze,
    {
      ref: n,
      classes: h,
      Icon: m,
      disabled: !1,
      onClick: u,
      size: l,
      ...p
    }
  );
});
bl.displayName = "SelectableChip";
export {
  Wl as AsyncSearch,
  Ll as GlobalCard,
  zn as GlobalCardBody,
  Nl as GlobalCardBodyCollapsible,
  Ol as GlobalCardFooter,
  jl as GlobalCardFooterLeftContent,
  ql as GlobalCardFooterRightContent,
  El as GlobalCardHeader,
  Al as GlobalCardHeaderAction,
  kl as GlobalCardHeaderCollapsible,
  Bl as GlobalCardHeaderContent,
  zl as GlobalCardHeaderMenu,
  Hl as GlobalCardHeaderTitle,
  Er as GlobalMenuItem,
  Br as GlobalMenuItemContent,
  Ar as GlobalMenuItemLeading,
  kr as GlobalMenuItemTrailing,
  tl as GlobalSideNavBar,
  Vr as GlobalSideNavBarBody,
  Tr as GlobalSideNavBarBodyMinimized,
  Mr as GlobalSideNavBarHeader,
  Mt as GlobalSideNavBarItem,
  Dt as GlobalSideNavBarItemMinimized,
  Dr as GlobalSideNavBarItemsList,
  Lr as GlobalSideNavBarItemsListMinimized,
  Jl as GlobalTable,
  cr as GlobalTableAlert,
  gr as GlobalTableAppliedFilters,
  yr as GlobalTableAutocompleteFilter,
  tr as GlobalTableBody,
  nr as GlobalTableBodyCell,
  or as GlobalTableBodyRow,
  is as GlobalTableBodyRowPanel,
  ur as GlobalTableBottomToolbar,
  Fr as GlobalTableCheckboxFilter,
  Ks as GlobalTableColumnActionMenu,
  ct as GlobalTableColumnActionsButton,
  br as GlobalTableColumnCheckbox,
  Ir as GlobalTableColumnsToggleButton,
  qs as GlobalTableColumnsToggleMenu,
  Yl as GlobalTableContainer,
  wr as GlobalTableDateFilter,
  Pr as GlobalTableDateRangeFilter,
  vr as GlobalTableDateTimeFilter,
  Gr as GlobalTableEditableCell,
  Js as GlobalTableFilterDrawer,
  xr as GlobalTableFilterDrawerToggleButton,
  sr as GlobalTableFooter,
  rr as GlobalTableFooterCell,
  lr as GlobalTableFooterRow,
  Zl as GlobalTableHead,
  er as GlobalTableHeadCell,
  Ql as GlobalTableHeadRow,
  ns as GlobalTableHeadSortLabel,
  dr as GlobalTableLinearProgressBar,
  _r as GlobalTableLinkCell,
  Cr as GlobalTableNumberFilter,
  hr as GlobalTableNumberRangeFilter,
  Rr as GlobalTablePagination,
  fr as GlobalTablePaginationSelect,
  ir as GlobalTableProvider,
  $r as GlobalTableRowToggleButton,
  pr as GlobalTableSearchFilter,
  Sr as GlobalTableSelectFilter,
  mr as GlobalTableTextFilter,
  ar as GlobalTableTopToolbar,
  zr as InputGroup,
  Hr as InputGroupItem,
  Qs as NavigationCard,
  bl as SelectableChip,
  Dl as TestComponent,
  Ul as createColumnHelper,
  fe as flexRender,
  Xl as useAsyncDebounce,
  Kl as useGlobalTable,
  V as useGlobalTableContext
};
//# sourceMappingURL=index.js.map
